<template>
  <div class="add_main">
    <el-card style="margin-bottom: 20px;">
      <div class="header_tit">
        <p class="red_box"></p>
        <span>商品信息</span>
      </div>
      <el-form ref="goodDetailForm" :model="goodDetailForm" label-width="140px">
        <el-form-item label="型号：">
          <el-input v-model="goodDetailForm.modelCode" disabled style="margin-right:10px;"></el-input>
          <!-- <span v-show="goodDetailForm.modelCode" style="margin-right:10px;">{{ goodDetailForm.modelCode }}</span> -->
          <el-button type="primary" @click="showModel">选择</el-button>
        </el-form-item>
        <!-- <el-form-item label="行话标签：">
          <el-checkbox-group v-model="goodDetailForm.jargonIds" @change="updateProName">
            <el-checkbox :label="item.id" v-for="(item, index) in jargonData" :key="index">{{ item.spuJargon
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="关键字：">
          {{ goodDetailForm.keyWords }}
        </el-form-item> -->
        <!-- <el-form-item label="关键字：">
          <el-input v-model="goodDetailForm.keyWord" placeholder="例：85英寸、海信、高色域" clearable
            @change="onKeywordChange"></el-input>
          <p class="colorRed">平台搜索流量巨大，设好关键词，更容易被搜到</p>
        </el-form-item>
        <el-form-item label="产品副标题：">
          <weditor @catchData="catchData" :isAddEditor="false" v-model="goodDetailForm.description"
            :content="goodDetailForm.description" :editorHeight="100"></weditor>
          <p class="colorRed">产品副标题（辅助搜索推荐使用），一般不填写，注意事项填写到下单须知板块</p>
        </el-form-item> -->

        <el-form-item label="商品供应商：">
          <autocomplete v-model="supmodelData" :placeholder="'请选择供应商（可搜索）'" @handleInput="handleSupInput"
            @handleSelect="handleSupSelect">
          </autocomplete>
        </el-form-item>
        <el-form-item label="商品类型：" class="productTypeSelect">
          <el-cascader v-model="goodDetailForm.typeIdList" ref="type_cascader"
            :props="{ value: 'id', label: 'typeName', children: 'childrens' }" :show-all-levels="true"
            :options="productNavTypeTreeList" placeholder="请选择类型" @change="handleSelType"></el-cascader>
          <div>
            <el-tag type="danger" size="small">商品类型至少选到2级！</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="商品品牌：">
          <autocomplete v-model="brandmodelData" @handleInput="handleBrandInput" @handleSelect="handleBrandSelect">
          </autocomplete>
        </el-form-item>
        <el-form-item label="参数设置：" required>
          <div>
            <el-tag style="margin-right: 10px;" v-for="(v, i) in goodDetailForm.parameters" :key="i">{{ v.key
              }}：{{
                v.value }}</el-tag>
          </div>
          <!-- <div v-if="paramsTypeList[0]">
            <div class="params_box" v-for="(item, index) in paramsTypeList" :key="index">
              <div v-if="item.propertyType == 10">
                <span class="from_tit">{{ item.propertyName }}</span>
                <el-input v-model="paramsTypeAddList[index]" placeholder="请输入参数" style="margin: 5px 0 0 0"
                  @change="bindParamsInput($event, index)"></el-input>
              </div>
              <div v-else-if="item.propertyType == 20">
                <span class="from_tit">{{ item.propertyName }}</span>
                <el-radio-group v-if="paramsTypeAddList[index]" v-model="paramsTypeAddList[index][0]"
                  style="margin-bottom: 0" @change="bindParamsRadio($event, index, item.id)">
                  <el-radio v-for="(v, i) in item.propertyValues" :key="i" :label="v.id">{{ v.propertyValue }}
                  </el-radio>
                  <el-radio :label="0">
                    <span>自定义</span>
                    <el-input v-model="item.extendPropertyValue" placeholder="请输入"
                      :disabled="paramsTypeAddList[index][0] != 0" style="
                          width: 150px;
                          display: inline-block;
                          margin-left: 10px;
                        " @change="(val) => {
                          onParamsInputChange(val, index, item.id);
                        }
                          "></el-input>
                  </el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.propertyType == 30">
                <span class="from_tit">{{ item.propertyName }}</span>
                <el-checkbox-group v-model="paramsTypeAddList[index]" style="margin-bottom: 0"
                  @change="bindParamsCheckbox($event, index)">
                  <el-checkbox v-for="(v, i) in item.propertyValues" :key="i" :label="v.id">{{ v.propertyValue }}
                  </el-checkbox>
                  <el-checkbox :label="0">
                    <span>自定义</span>
                    <el-input v-model="item.extendPropertyValue" placeholder="请输入"
                      :disabled="!paramsTypeAddList[index].includes(0)" style="
                          width: 150px;
                          display: inline-block;
                          margin-left: 10px;
                        " @change="(val) => {
                          onParamsInputChange(val, index, item.id);
                        }
                          "></el-input>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div v-else>无参数组</div>
          <p class="colorRed">选择后更容易被分类与搜索</p> -->
        </el-form-item>
        <el-form-item label="系列名：">
          {{ goodDetailForm.seriesName }}
        </el-form-item>
        <el-form-item label="卖点：">
          {{ goodDetailForm.simpleSellingPoint }}
        </el-form-item>
        <el-form-item label="补充卖点：">
          <el-input v-model="goodDetailForm.extraSellingPoint" @input="updateProName" :maxlength="8"></el-input>
        </el-form-item>
        <el-form-item label="商品名称：">
          <el-input v-model="goodDetailForm.proName" clearable disabled></el-input>
          <p class="colorRed">{{ proNameMessage }}</p>
        </el-form-item>
        <el-form-item label="下单须知：" required>
          <weditor @catchData="catchDetailData3" :isAddEditor="true" v-model="goodDetailForm.orderNotice"
            :content="goodDetailForm.orderNotice" :editorHeight="200"></weditor>
        </el-form-item>

        <el-form-item label="69码：">
          <el-input v-model="goodDetailForm.code69" disabled></el-input>
        </el-form-item>
        <el-form-item label="视频：">
          <div class="img-box">
            <el-upload class="el_upload el_upload_video" action="#" :auto-upload="false" :show-file-list="false"
              :on-change="(file) => handleChange(file, 7)">
              <video v-if="videoUrl" :src="videoUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span class="mask" v-if="videoUrl">
                <span @click.stop="delPic(7)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </el-upload>
            <div v-if="videoUrl" class="videoPreview">
              <video :src="videoUrl" style="width: 100%"></video>
              <p class="play_btn" @click.stop="playFromSucao()">
                <i class="el-icon-caret-right"></i>
              </p>
            </div>
          </div>
          <!--            <el-row>-->
          <!--              <el-col :span="24">-->
          <!--                <p><strong>本地上传视频支持MP4格式，大小不超过20M</strong></p>-->
          <!--              </el-col>-->
          <!--            </el-row>-->

        </el-form-item>
        <el-form-item label="商家图册：">
          <draggable :list="goodDetailForm.businessPics" animation="500" :move="onMoveB"
            style="position: relative; display: flex; flex-wrap: wrap">
            <div class="image-box" v-for="(item, index) in goodDetailForm.businessPics" :key="index">
              <template v-if="item.spuPicUrl">
                <p class="del_box" @click.stop="handleDelPic(index, 1)">
                  <img src="../../assets/del-icon.png" alt />
                </p>
                <img class="img" :src="item.spuPicUrl" alt @click.stop="handleBigPic(item.spuPicUrl)" />
              </template>
              <el-upload v-else class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
                :on-change="(file) => handleBusinessPic(file, index)" style="line-height: 0;">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p class="text"><span v-if="index == 2" class="colorRed">*</span>{{ titleMapB[index] }}</p>
              <p v-if="index == 0 && item.isMain" class="text">主图</p>
              <template v-if="[2, 3, 4].includes(index)">
                <p class="text">
                  <el-button size="mini" @click.stop="setMain(index, 1)">{{ item.isMain ? "主图" : "设为主图" }}
                  </el-button>
                </p>
                <p class="text">
                  <el-button size="mini" @click.stop="setHome(index, 1)">{{ item.isHome ? "首页展示图" : "设为首页展示图" }}
                  </el-button>
                </p>
              </template>
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleBusinessOtherPic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="图册复制：" v-if="goodDetailForm.businessPics[0]">
          <el-button type="warning" @click="handleCopy">同步</el-button>
          <span style="color: #409EFF; margin-left: 20px;">（一键将B端图册同步到C端图册）</span>
        </el-form-item>
        <el-form-item label="C端图册：">
          <draggable :list="goodDetailForm.customerPics" animation="500" :move="onMoveC"
            style="position: relative; display: flex; flex-wrap: wrap">
            <div class="image-box" v-for="(item, index) in goodDetailForm.customerPics" :key="index">
              <template v-if="item.spuPicUrl">
                <p class="del_box" @click.stop="handleDelPic(index, 2)">
                  <img src="../../assets/del-icon.png" alt />
                </p>
                <img class="img" :src="item.spuPicUrl" alt @click.stop="handleBigPic(item.spuPicUrl)" />
              </template>
              <el-upload v-else class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
                :on-change="(file) => handleCustomerPic(file, index)" style="line-height: 0;">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p class="text">{{ titleMapC[index] }}</p>
              <template v-if="[0, 1, 2].includes(index)">
                <p class="text">
                  <el-button size="mini" @click.stop="setMain(index, 2)">{{ item.isMain ? "主图" : "设为主图" }}
                  </el-button>
                </p>
                <p class="text"><el-button size="mini" @click.stop="setShare(index)">{{ item.isClientShare ? "分享图" :
                  "设为分享图" }}
                  </el-button></p>
                <p class="text"><el-button size="mini" @click.stop="setHome(index, 2)">{{ item.isHome ? "首页展示图" :
                  "设为首页展示图" }}
                  </el-button></p>
              </template>
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleCustomerOtherPic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="商品描述：">
          <weditor @catchData="catchDetailData" :isAddEditor="true" v-model="goodDetailForm.proContent"
            :content="goodDetailForm.proContent" :editorHeight="500"></weditor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-preventClick @click="handleSave" v-show="isCanSaveBtn && $route.query.id">保存
          </el-button>
        </el-form-item>
        <el-form-item label="区域限购：">
          <!-- <el-select v-model="goodDetailForm.areaLimtId" filterable placeholder="请选择区域限购" clearable
            :disabled="isGift">
            <el-option v-for="item in restaurantsArea" :key="item.AreaLimitName" :label="item.AreaLimitName"
              :value="item.Id"></el-option>
          </el-select> -->
          <el-autocomplete v-model="goodDetailForm.areaLimtName" clearable :fetch-suggestions="querySearchAsyncArea"
            placeholder="请输入内容" @select="handleSelectArea" @clear="handleClearArea"></el-autocomplete>
          <el-button type="primary" @click="regionalRestrictions" style="margin-left: 10px">区域限购</el-button>
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="goodDetailForm.isShelves">
            <el-radio :label="true">上架</el-radio>
            <el-radio :label="false">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商家起购数量：" style="margin-bottom: 10px">
          <el-input v-model="goodDetailForm.minBuyNum" placeholder="请输入商家起购数量"></el-input>
        </el-form-item>
        <!-- <el-form-item label="商品概述：">
          <div class="flex-wrap flex-start" style="width: 100%;">
            <el-tooltip class="item" effect="dark" content="用户发送商品链接时自动回复" placement="top-start">
              <div class="query-icon">?</div>
            </el-tooltip>
            <el-input v-model="goodDetailForm.summary" type="textarea"></el-input>
          </div>
          <p class="colorRed">自动抓取，下单须知与核心卖点</p>
        </el-form-item> -->
        <template>
          <el-form-item label="入户商品：">
            <el-switch v-model="goodDetailForm.isInRoom" active-text="是" inactive-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item label="" v-if="goodDetailForm.isInRoom">
            <el-input type="textarea" placeholder="请输入" style="width:100%;" rows="5"
              v-model="goodDetailForm.inRoomNotice"></el-input>
            <p style="color:red;">用户下单时不符合入户地址要求时将进行内容提醒</p>
          </el-form-item>
        </template>
        <!-- 现货/预售/抢单 -->
        <template>
          <el-form-item label="活动：">
            <el-radio-group @change="changeType" v-model="goodDetailForm.promoteTag">
              <el-radio :label="0">现货</el-radio>
              <el-radio :label="1">预售</el-radio>
              <el-radio :label="2">抢单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发货时效：" v-if="goodDetailForm.promoteTag === 0">
            <el-select v-model="goodDetailForm.deliveryTimeTag" placeholder="请选择">
              <el-option v-for="item in deliveryTime1" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="goodDetailForm.promoteTag !== 0">
            <el-form-item label="活动结束时间：" style="padding-bottom: 10px">
              <el-date-picker v-model="goodDetailForm.promoteEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="活动结束发货时效：">
              <el-select v-model="goodDetailForm.promoteDeliveryTimeTag" placeholder="请选择">
                <el-option v-for="item in deliveryTime" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="系统直连：" style="margin: 15px 0">
              <el-radio-group v-model="goodDetailForm.isPromoteEndTimeKeepSend">
                <el-radio :label="true">保持直连</el-radio>
                <el-radio :label="false">断开直连，预售时间到后直连</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="规则：">
              <!-- <wangEditor4 ref="editor4" @catchData4="catchDetailData4" :isAddEditor="true"
                v-model="goodDetailForm.PromoteRule" :content="goodDetailForm.PromoteRule" :editorHeight="200">
              </wangEditor4> -->
              <weditor @catchData="catchDetailData4" :isAddEditor="true" v-model="goodDetailForm.promoteRule"
                :content="goodDetailForm.promoteRule" :editorHeight="200"></weditor>
            </el-form-item>
          </el-form-item>
        </template>
        <!-- 商家端账号限购 -->
        <template>
          <el-form-item label="商家端账号限购：">
            <el-switch v-model="isBusinessLimit" @change="handleSwitch($event, 2)" active-color="#13ce66"
              inactive-color="#ccc">
            </el-switch>
            <el-form style="padding-top: 10px">
              <el-tabs v-model="activeBName" type="card" @tab-click="handleBClick">
                <el-tab-pane :disabled="!isBusinessLimit || isGift" label="商家端账号限购" name="first">
                  <el-form-item label="商家限购数量：" style="margin-bottom: 10px">
                    <el-input-number class="limit-input" :disabled="!isBusinessLimit || isGift" :controls="false"
                      style="width: 80px" v-model="goodDetailForm.businessAccountLimitNum" :min="0"></el-input-number>
                    <el-checkbox :disabled="!isBusinessLimit || isGift" v-model="goodDetailForm.isAllowBusinessSkipArea"
                      style="margin-left: 10px">允许区级地址不同购买
                    </el-checkbox>
                    <el-checkbox :disabled="!isBusinessLimit || isGift" v-model="goodDetailForm.isAllowBusinessReceiver"
                      style="margin-left: 10px">允许不同收货人
                    </el-checkbox>
                    <el-checkbox :disabled="!isBusinessLimit || isGift"
                      v-model="goodDetailForm.isAllowBusinessSkipAddress" style="margin-left: 10px">允许不同地址
                    </el-checkbox>
                    <el-checkbox :disabled="!isBusinessLimit || isGift"
                      v-model="goodDetailForm.isAllowBusinessReceiverPhone" style="margin-left: 10px">允许不同收货手机
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item label="限购判断时间：" style="margin-bottom: 10px">
                    <el-date-picker :disabled="!isBusinessLimit || isGift"
                      v-model="goodDetailForm.businessAccountLimitTime" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 10px">
                    <el-checkbox v-model="goodDetailForm.isDoubleBusinessAccountLimitNum">允许等级会员限购数量翻倍</el-checkbox>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane :disabled="!isBusinessLimit || isGift" label="单笔下单限制" name="second">
                  <el-form-item>
                    单个订单最多下
                    <el-input-number :controls="false" style="width: 80px" :disabled="!isBusinessLimit || isGift"
                      v-model="goodDetailForm.businessBuyNumLimitNum" :min="0"></el-input-number>
                    台
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 10px">
                    <el-checkbox v-model="goodDetailForm.isDoubleBusinessBuyNumLimitNum">允许等级会员限购数量翻倍</el-checkbox>
                  </el-form-item>
                </el-tab-pane>
              </el-tabs>
            </el-form>
            <p class="colorRed">
              两者只能同时生效一个；商家账号限购:该账号最高下单数量；单笔下单限制:一个订单最多下单数量
            </p>
            <p class="colorRed">限购判断时间:规则生效起始时间</p>
          </el-form-item>
        </template>
      </el-form>
    </el-card>
    <el-card style="margin-bottom: 20px;">
      <div class="header_tit">
        <p class="red_box"></p>
        <span>规格列表</span>
      </div>
      <div class="tab_box">
        <div style="margin: 0 0 20px 60px">
          <el-radio-group v-model="goodDetailForm.isSingleSpec" :disabled="goodDetailForm.platformType > 0">
            <el-radio :label="true">单规格</el-radio>
            <el-radio :label="false">多规格</el-radio>
          </el-radio-group>
        </div>
        <div v-if="goodDetailForm.isSingleSpec">
          <el-form label-width="140px" v-if="oneSkuList[0]">
            <el-form-item label="商品图片：">
              <div class="cell single_up_img">
                <div class="el_upload_sku">
                  <input class="el_upload_input" @change="handleSkuChange($event)" id="el_upload_input" type="file" />
                  <img v-if="oneSkuList[0].skuPicUrl" :src="oneSkuList[0].skuPicUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="mask" v-if="oneSkuList[0].skuPicUrl" @click.stop="delSkuPic()">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="供应商商品编码：">
              <el-input v-model="oneSkuList[0].supSkuCode" placeholder="请输入供应商商品编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="默认库存：">
              <el-input v-model="oneSkuList[0].defaultStock" placeholder="请输入默认库存" clearable></el-input>
              <el-button style="margin-left: 10px" @click="setRegStock(0)">设置库存
              </el-button>
            </el-form-item>
            <el-form-item label="多级库存：">
              <el-switch v-model="oneSkuList[0].isEnableMultistageStock">
              </el-switch>
              <el-button style="margin-left:10px" @click="stockDetail(oneSkuList[0])">多级库存管理
              </el-button>
            </el-form-item>
            <el-form-item label="供货价格：">
              <el-input v-model="oneSkuList[0].billPrice" placeholder="请输入供货价格" clearable @input="billPriceInput"
                @change="billPriceChange"></el-input>
            </el-form-item>
            <el-form-item label="商家价格：" v-if="priceType !== 1">
              <el-input v-model="oneSkuList[0].merchantPrice" placeholder="请输入商家价格" clearable></el-input>
            </el-form-item>
            <el-form-item label="零售价格：" v-if="priceType !== 1">
              <el-input v-model="oneSkuList[0].customerPrice" placeholder="请输入零售价格" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="市场价格：" v-if="priceType !== 1">
              <el-input v-model="oneSkuList[0].marketPrice" placeholder="请输入市场价格" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="毛利率(%)：" v-if="priceType !== 1">
              <el-input v-model="oneSkuList[0].grossProfit" placeholder="毛利率" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <el-form label-width="140px" :inline="true">
            <el-form-item label="选择规格：">
              <el-select v-model="selectScepId" v-loadmore="loadMore" :remote-method="(e) => remoteMethod(e)"
                placeholder="请输入规格名称" filterable remote>
                <el-option v-for="item in restaurantsSpe" :key="item.id" :value="item.id" :label="item.specName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="selectScep" size="small" type="success">添加
              </el-button>
            </el-form-item>
          </el-form>
          <el-form>
            <el-form-item :label="`${item.label}:`" label-width="130px" v-for="(item, index) in selAllSpec"
              :key="index">
              <el-checkbox-group v-model="item.selScepIds" style="margin: 0 20px 0 10px; display: inline-block">
                <el-checkbox v-for="(v, i) in item.data" :key="i" :label="v.id" @change="selCheckboxFun">{{ v.specValue
                  }}
                </el-checkbox>
              </el-checkbox-group>
              <el-button type="danger" icon="el-icon-delete" circle @click="delSpecValue(index)"></el-button>
            </el-form-item>
          </el-form>
          <div id="container" class="el-table" v-if="createSkuList[0]">
            <el-table border :data="createSkuList">
              <el-table-column label="规格名称" align="center">
                <template slot-scope="scope">
                  <div class="cell">
                    <span style="font-size: 12px">{{ scope.row.specName }}</span>
                    <el-switch v-if="scope.row.Id" v-model="scope.row.IsEnableMultistageStock" active-color="#13ce66"
                      inactive-color="#ff4949" style="margin-left: 10px">
                    </el-switch>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="供应商商品编码" align="center">
                <template slot-scope="scope">
                  <el-input type="text" v-model="scope.row.supSkuCode"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="默认库存" align="center" width="300">
                <template slot-scope="scope">
                  <div class="cell" style="display: flex;">
                    <div>
                      <el-input type="number" v-model="scope.row.defaultStock"
                        style="min-width: 80px;max-width: 100px;margin-right: 10px;"></el-input>
                    </div>
                    <div>
                      <div>
                        多级库存：
                        <el-switch v-model="scope.row.isEnableMultistageStock">
                        </el-switch>
                      </div>
                      <el-button style="margin:10px 0" size="mini" @click="setRegStock(scope.$index)">区域库存
                      </el-button>
                      <el-button size="mini" @click="stockDetail(scope.row)">多级库存管理
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="供货价格" align="center">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.billPrice" @input="billPriceInput2(scope.row)"
                    @change="billPriceChange2(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="商家价格" align="center" v-if="priceType !== 1">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.merchantPrice"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="零售价格" align="center" v-if="priceType !== 1">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.customerPrice"></el-input>
                </template>
              </el-table-column>
              <!-- <el-table-column label="市场价格" align="center" v-if="priceType !== 1">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.marketPrice"></el-input>
                </template>
              </el-table-column> -->
              <el-table-column label="毛利率(%)" align="center" v-if="priceType !== 1">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.grossProfit" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column label="规格图" align="center">
                <template slot-scope="scope">
                  <div class="cell up_img">
                    <div class="el_upload_sku">
                      <input class="el_upload_input" @change="handleSkuChange($event, scope.$index)"
                        id="el_upload_input" type="file" />
                      <img v-if="scope.row.skuPicUrl" :src="scope.row.skuPicUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <span class="mask" v-if="scope.row.skuPicUrl" @click.stop="delSkuPic(scope.$index)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="sbmit_info">
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-card>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 批量下载商品图册 -->
    <div class="download_box" v-if="spuId && isShowDownload">
      <downloadpic :businessPics="goodDetailForm.businessPics" :customerPics="goodDetailForm.customerPics"
        :proContent="goodDetailForm.proContent"></downloadpic>
    </div>
    <!-- 区域库存设置 -->
    <el-dialog title="区域库存设置" :visible.sync="regStockVisible" :close-on-click-modal="false">
      <regstock v-model="goodDetailForm" :areaStockIndex="areaStockIndex" :regStockSkuId="regStockSkuId"
        :isSingleSpec="goodDetailForm.isSingleSpec" ref="regstock" v-if="regStockVisible"></regstock>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="regStockVisible = false">取消</el-button>
        <el-button type="primary" @click.native="setAreaShowSubmit">提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 库存详情 -->
    <el-dialog title="库存详情" :visible.sync="areaVisible" width="80%" :close-on-click-modal="false">
      <warehousedetails :skuId="skuId"></warehousedetails>
    </el-dialog>
    <!-- 视频弹窗 -->
    <div v-show="showVideo" class="videoWrap" @click="hideVedio">
      <transition name="el-zoom-in-center">
        <div v-show="showVideo" class="videoWrapInner" @click.stop>
          <video :src="videoUrl" width="600" height="400" controls="controls">
            您的浏览器暂不支持video标签
          </video>
        </div>
      </transition>
    </div>
    <!-- 选择型号 -->
    <el-dialog title="选择型号" width="30%" center :visible.sync="modelVisible" :close-on-click-modal="false">
      <el-form label-width="0">
        <el-form-item label="">
          <el-autocomplete class="inline-input" v-model="selectModelData.modelCode" :fetch-suggestions="querySearch"
            :disabled="selectModelData.disabled" placeholder="请输入内容" @select="handleModelCodeSelect"></el-autocomplete>
          <el-button type="text" v-show="selectModelData.id" @click="reSelect" style="padding-left:15px;">重选</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" :disabled="isDisbaled" plain v-preventClick
          @click="handleSelectModel(1)">只带型号</el-button>
        <el-button type="primary" :disabled="isDisbaled" v-preventClick @click="handleSelectModel(2)">确定</el-button>
      </div>
    </el-dialog>
    <!-- 商品名称信息确认 -->
    <el-dialog title="商品名称信息确认" :visible.sync="proNameConfirmVisible" width="30%" :before-close="() => {
      proNameConfirmVisible = false;
    }
      ">
      <el-input style="width: 100%" type="textarea" :autosize="{ minRows: 3 }" v-model="goodDetailForm.proName"
        disabled>
      </el-input>
      <p v-if="!proNameConfirmFlag" style="margin-top: 10px; line-height: 1.8" v-html="proNameConfirmText"></p>
      <span slot="footer">
        <el-button v-if="proNameConfirmFlag" @click="proNameConfirmVisible = false">返回修改</el-button>
        <el-button v-if="proNameConfirmFlag" type="success" @click="submitProInfo">立即提交</el-button>
        <el-button v-if="!proNameConfirmFlag" @click="submitProInfo">提交不规范信息</el-button>
        <el-button v-if="!proNameConfirmFlag" @click="proNameConfirmVisible = false" type="primary">返回修改</el-button>
      </span>
    </el-dialog>
    <imageCropper :visible="dialogCropperVisible" :imgFile="imageFile" :ratio="[1, 1]" :minWidth="800" :minHeight="800"
      @success="handleCropSuccess" />
    <stockDetail ref="stockDetail" />
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  getQiniuToken,
  GetAllReseller,

  productNavTypeTree, //获取商品类型
  getBrandListPage, //品牌列表
  busSupplierList, //供应商列表
  getAreaLimitListPage, //区域限购模板列表
  getByTypeId, //根据类型获取参数
  getSpecListPage, //获取规格列表
  getSpecValueList,
  addProductSpu, //上传商品
  productSpuDetail, //商品详情
  updateProductSpu, //商品编辑
  BatchUpdateSkuPriceCheck,
  GetProductSpuTrackList,
  couponList, // 优惠券列表
  JDProductSearch,
  GetApprovalAfterPrice, // 获取审批中的返价
  PartUpdate,
  SpuModelGetSimpleList,
  SpuModelGetDetail,
  PushSkuWarehousingToANNTO,
  PushSkuToANNTO,
  QuerySkuItem,
  AddOrUpdateSkuItem,
  Product_MultistageStockList,
  areaList,
  GetReturnMemberRebateConfig
} from "../../api/api";
import draggable, { set } from "vuedraggable";
import weditor from "../../components/WangEditor";
import autocomplete from "../../components/autocomplete";
import regstock from "./components/Regstock";
// import areafreight from "./AreaFreight";
// import areaShow from "./setShowArea";
// import gift from "./Gift";
import downloadpic from "../../components/DownloadPic.vue"
import warehousedetails from "./components/WarehouseDetails.vue";
import { getButtonList } from "../../promissionRouter";
// import PullProduct from "./PullProduct";
// import GrossProfit from "../TagManagement/GrossProfit";
// import maoriApproval from "./MaoriApprovalAll.vue";
// import productApproval from "./productApproval.vue";
// import tieredPriceApproval from './tieredPriceApproval.vue'
import { isInSupplyerList } from "../../../util/filter";
// import wangEditor2 from "../../components/WangEditor2.vue";
// import wangEditor1 from "../../components/WangEditor1.vue";
// import wangEditor3 from "../../components/WangEditor3.vue";
// import wangEditor4 from "../../components/WangEditor4.vue";
import imageCropper from "../../components/imageCropper.vue";
import stockDetail from "./components/stockDetail.vue";

export default {
  components: {
    weditor,
    regstock,
    autocomplete,
    draggable,
    warehousedetails,
    downloadpic,
    imageCropper,
    stockDetail
  },
  watch: {
    createSkuCopyList() {
      if (this.createSkuCopyList.length < this.createSkuList.length) {
        this.createSkuCopyList.forEach((v, i) => {
          this.createSkuList[i] = v;
        });
      } else if (this.createSkuCopyList.length > this.createSkuList.length) {
        this.createSkuCopyList.forEach((v, i) => {
          if (i <= this.createSkuList.length - 1) {
            this.createSkuList[i] = v;
          }
        });
      }
    },
    'goodDetailForm.isInRoom'(n, o) {
      if (n && !o) {
        // 每次开启入户商品时，重新获取入户商品模版
        this.getInRoomContent()
      }
    },
    // "goodDetailForm.typeId": {
    //   handler(n, o) {
    //     if (this.$refs['cascaderCategory'].getCheckedNodes()[0]) {
    //       let arr = this.$refs['cascaderCategory'].getCheckedNodes()[0].pathNodes;
    //       this.goodDetailForm.typeIdList = [];
    //       arr.forEach(x => {
    //         this.goodDetailForm.typeIdList.push(x.value,);
    //       })
    //     }
    //   },
    //   deep: true
    // },
    'goodDetailForm.brandId'(n, o) {
      if (!this.isFirstLoad) {
        this.getGargonData()
        this.getKeyWordData(() => {
          this.updateProName()
        })
      }
    },
    'goodDetailForm.typeIdList'(n, o) {
      if (!this.isFirstLoad) {
        this.getGargonData()
        this.getKeyWordData(() => {
          this.updateProName()
        })
      }
    },
    'goodDetailForm.modelCode'(n, o) {
      if (!this.isFirstLoad) {
        this.getGargonData()
        this.getKeyWordData(() => {
          this.updateProName()
        })
      }
    },
  },
  data() {
    return {
      copyId: this.$route.query.copyid ? this.$route.query.copyid : null,
      priceType: null,
      supType: null,
      ResellerId: null,
      values: '',
      values1: '',
      deliveryTime1: [
        {
          value: 0,
          label: "暂无时效设置",
        },
        {
          value: 1,
          label: "24小时",
        },
        {
          value: 2,
          label: "48小时",
        },
        {
          value: 3,
          label: "72小时",
        },
        {
          value: 4,
          label: "4天",
        },
        {
          value: 5,
          label: "5天",
        },
        {
          value: 6,
          label: "6天",
        },
        {
          value: 7,
          label: "7天",
        },
        {
          value: 14,
          label: "14天",
        },
      ],
      deliveryTime: [
        {
          value: 1,
          label: "24小时",
        },
        {
          value: 2,
          label: "48小时",
        },
        {
          value: 3,
          label: "72小时",
        },
        {
          value: 4,
          label: "4天",
        },
        {
          value: 5,
          label: "5天",
        },
        {
          value: 6,
          label: "6天",
        },
        {
          value: 7,
          label: "7天",
        },
        {
          value: 14,
          label: "14天",
        },
      ],
      ComeCome: false,
      showVideo: false,
      videoUrl: '',
      isShowCostPrice: false,
      spuId: this.$route.query.id ? this.$route.query.id : null,
      isGift: this.$route.query.isgift
        ? JSON.parse(this.$route.query.isgift)
        : false,
      qiniuToken: "",
      routerId: null,
      isStrickPriceShow: false, // 是否显示到手价
      goodDetailForm: {
        orderNotice: '',
        sellingPoint: '',
        applicablePeople: '',
        promoteTag: 0, //发货时效
        deliveryTimeTag: 0, //发货时效
        promoteEndTime: null, //发货时效
        promoteDeliveryTimeTag: 0,
        isPromoteEndTimeKeepSend: false, // 是否直连
        promoteRule: '',
        enabled: null, //是否下单返利
        proName: null, //商品名称
        modelCode: null, //型号
        keyWord: null, //关键字
        description: null, //补充描述
        brandId: null, //商品品牌
        supId: null, //供应商ID
        typeId: null, //类型Id
        typeIdList: [], //类型Id数组
        salesSeed: 0, //销量基数
        preSaleTime: null, //预售时间
        isUseCoupon: true, //是否使用优惠卷
        isShowShareProfit: true, //是否显示分享赚
        isPageShow: true,
        isSensitive: false, // 是否敏感商品
        isStructure: false, // 是否为结构机
        isGift: false,
        isHasClientGift: false,
        payEffectiveTime: 0,
        isCustomerAccountLimit: false, //C端限购
        customerAccountLimitNum: null, //C端限购的数量
        isAllowCustomerSkipArea: false, //是否允许同一地区购买
        isBusinessAccountLimit: false, //B端限购
        businessAccountLimitNum: null, //B端限购数量
        isAllowBusinessSkipArea: false, //是否允许同一地区限购
        isAllowBusinessReceiver: false, // 不应许收货人重复
        isAllowBusinessSkipAddress: false, // 不应许地址重复
        isAllowBusinessReceiverPhone: false, // 不应许收货手机重复
        limitAddressWord: null, // 收货地址文字过滤
        businessAccountLimitTime: new Date(), //B限购判断时间：
        isDoubleBusinessAccountLimitNum: false, // 允许等级会员账号限购数量翻倍
        isDoubleBusinessBuyNumLimitNum: false, // 允许等级会员单词限购数量翻倍
        customerAccountLimitTime: new Date(), //C限购判断时间
        isCustomerBuyNumLimit: false, //C端账号限购
        isBusinessBuyNumLimit: false, //B端账号限购
        properties: [], //参数设置
        isShowBusiness: true, //B显示位置
        isRecommend: true, // 是否被推荐
        isBusinessBuy: false, //是否屏蔽商户购买
        isShowCustomer: true, //C显示位置
        areaLimtId: null, //区域限购ID
        areaLimtName: null, //区域限购ID
        isAreaLimt: false,
        isAreaShow: false, //区域显示
        isThirdOrderDirect: true,
        areaShows: [], //区域显示数据
        isPostageFree: true, //是否包邮
        minBuyNum: 1, //最小购买数量
        minCustomerBuyNum: 1,
        proContent: "", //商品详情富文本
        isSingleSpec: true, //规格
        isShelves: false, //状态
        isPriceLock: false,
        tagList: [],
        customerPics: [
          {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 3
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 4
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 5
          },
          {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 6
          }
        ], //C端图册
        businessPics: [
          {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 1
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 2
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 3
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 4
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 5
          }, {
            isClientShare: false,
            isHome: false,
            isMain: false,
            spuPicUrl: "",
            type: 6
          }
        ], //B端图册
        skus: [
          {
            skuPicUrl: null,
            supSkuCode: null,
            defaultStock: null,
            costPrice: 0,
            marketPrice: 0,
            customerPrice: 0,
            merchantPrice: null,
            billPrice: 0, // 开单价
            thirdPrice: 0,//三方价
            afterPrice: 0,//后返价
            areaStocks: [],
            strikePrice: null, // 到手价
            performanceFee: null,
            grossProfit: 0, // 单规格毛利
            isInstallSubsidy: false,
            installSubsidyVal: null,
          },
        ],
        isCanReturn: true,
        isNotPurchasePolicyStats: false,
        isOrderGiftCoupon: false,
        giftCouponIds: [],
        isPreSale: false,
        preSaleDescribe: '',
        summary: null, // 商品概况
        // IsMemberBeanRebate: true,
        // IsMemberBeanUse: true
        isInRoom: false,
        inRoomNotice: '',
        keyWords: "",
        jargonIds: [],
        parameters: [],
        seriesName: "",
        simpleSellingPoint: "",
        extraSellingPoint: ""
      },
      isBusinessLimit: false,
      activeCName: "first",
      activeBName: "first",

      brandmodelData: {
        name: "",
        restaurants: [],
      },
      supmodelData: {
        name: "",
        restaurants: [],
      },
      modelTempData: {
        name: "",
        restaurants: [],
      },
      restaurants: [],
      productNavTypeTreeList: [], //商品类型
      paramsTypeList: [], // 参数列表

      paramsTypeAddList: [], //根据已添加的参数组动态的添加参数

      selectScepId: null, //添加规格
      selectScepIds: [], //判断是否已经添加过该规格
      createSkuList: [], //多规格最终生成的数组
      createSkuCopyList: [],
      //级联选择器数据最终处理
      cascaderTypeId: [],

      regStockVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      restaurantsArea: [],
      restaurantsSpe: [],
      selAllSpec: [],

      areaStockIndex: -1, //用于记录点击库存的index
      regStockSkuId: 0, //获取各个库存的SkuId

      isShowGift: false,

      pageIndex: 1,
      flag: false,
      oneSkuList: [
        {
          skuPicUrl: null,
          supSkuCode: null,
          defaultStock: null,
          costPrice: 0,
          marketPrice: 0,
          customerPrice: 0,
          merchantPrice: null,
          billPrice: 0,
          thirdPrice: 0,
          areaStocks: [],
          skuSpecs: null,
          orderRebate: 0,
          quarterRebate: 0,
          yearRebate: 0,
          stageRebate: 0,
          strikePrice: null, // 到手价
          performanceFee: null,
          grossProfit: 0, // 单规格毛利
          isInstallSubsidy: false,
          installSubsidyVal: null,
        },
      ],

      areaVisible: false,
      skuId: null,
      total: 0,
      operationData: {
        pageIndex: 1,
        pageSize: 10
      },
      trackList: [],

      arrImages: [],
      isShowDownload: false,
      isCanEditPrice: false,
      isCanSubmitBtn: false,
      isCanSaveBtn: false,
      isCanPull: false,
      couponList: [],
      detail: {},
      approvalAfterPrice: '',
      StandardRate: 0, //标准利率
      isCanclProductBeanApprove: false,
      isCanclTieredPricingAudit: false, // 阶梯价格作废
      isGetReturnMemberRebateConfig: false, // 盟友豆

      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      provinceId: null,
      cityId: null,
      districtId: null,
      townId: null,
      outCodeList: [],
      dialogPushInfo: false,
      andeForm: {
        SpuId: null,
        SkuId: null,
        SenderName: null,
        SenderTel: null,
        SenderProvinceName: null,
        SenderCityName: null,
        SenderDistrictName: null,
        SenderTownName: null,
        SenderDetailAddr: null,
        Num: null,
        OutWarehouseCode: null
      },
      extendSku: {
        SpuId: null,
        SkuId: null,
        Length: null,
        Width: null,
        Height: null,
        Weight: null,
        Cube: null,
        IsParent: 0
      },
      modelVisible: false,
      selectModelData: {
        id: null,
        modelCode: null,
        disabled: false
      },
      isDisbaled: false,
      activityConfig: {},
      kxykSkulist: [],
      proNameConfirmVisible: false,
      proNameConfirmFlag: false,
      proNameConfirmText: "",
      typeNameString: '', // 品类的全称
      proNameMessage: "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 行话标签 + 参数 + 关键词",
      isFirstLoad: this.$route.query.id ? true : false,
      jargonData: [],
      dialogCropperVisible: false,
      imageFile: null,
      imageIndex: null,
      imageType: 1,
      titleMapB: {
        0: '白底图',
        1: '透明图',
        2: '主图(场景图)1',
        3: '主图(场景图)2',
        4: '主图(场景图)3',
        5: '参数图',
      },
      titleMapC: {
        0: '主图(场景图)1',
        1: '主图(场景图)2',
        2: '主图(场景图)3',
        3: '参数图',
      },
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    this.isShowCostPrice = buttonList.filter((i) => {
      return i.Func == "showCostPrice";
    }).length;
    this.isShowDownload = buttonList.filter((i) => {
      return i.Func == "handleDownload";
    }).length;
    this.isCanEditPrice = buttonList.filter((i) => {
      return i.Func == "canNotEditPrice";
    }).length;
    this.isCanSubmitBtn = buttonList.filter((i) => {
      return i.Func == "isCanSubmit";
    }).length;
    this.isCanSaveBtn = buttonList.filter((i) => {
      return i.Func == "isCanSaveBtn";
    }).length;
    this.isCanPull = buttonList.filter((i) => {
      return i.Func == "PullJD";
    }).length;
    this.isCanclProductBeanApprove = buttonList.find((i) => {
      return i.Func == "canclProductBeanApprove";
    }) ? true : false;
    this.isCanclTieredPricingAudit = buttonList.find((i) => {
      return i.Func == "canclTieredPricingAudit";
    }) ? true : false;
    this.isGetReturnMemberRebateConfig = buttonList.find((i) => {
      return i.Func == "getReturnMemberRebateConfig";
    }) ? true : false;
    // console.log(this.isCanEditPrice);
    this.getProductSpuDetail();
    this.getQiniuToken();
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getBusSupplierList();
    // this.getAreaList();
    // this.getSpecList();
    // this.GetApprovalAfterPrice();
    this.ComeCome = false
    // if (this.$route.query.copyid) {
    //   this.getCopySpuData()
    // }
  },
  methods: {
    onMoveB(evt) {
      // 当前拖动项索引
      const oldIndex = evt.draggedContext.index;
      // 目标位置索引
      const newIndex = evt.relatedContext.index;
      // 前6个固定
      if (oldIndex <= 5) {
        return false;
      }
      // 不允许拖到前6个区域
      if (newIndex <= 5) {
        return false;
      }
      return true;
    },
    onMoveC(evt) {
      // 当前拖动项索引
      const oldIndex = evt.draggedContext.index;
      // 目标位置索引
      const newIndex = evt.relatedContext.index;
      // 前4个固定
      if (oldIndex <= 3) {
        return false;
      }
      // 不允许拖到前4个区域
      if (newIndex <= 3) {
        return false;
      }
      return true;
    },
    getInRoomContent() {
      if (!this.goodDetailForm.inRoomNotice) {
        KSAXApiRequest({ path: 'Suppliers/GetInRoomNotice', parmsJson: { id: this.ResellerId } }).then(res => {
          if (res.data.success) {
            this.goodDetailForm.inRoomNotice = res.data.response.inRoomNotice
          } else {
            this.goodDetailForm.inRoomNotice = '该产品为入户产品，下单需要提供详细入户地址，精确到实际门牌号，楼栋号，房间号（举例：XX市XX区XX县XX路XX小区XX号楼XX室）'
          }
        })
      }
    },
    getCopySpuData() {
      let data = {
        path: 'Product_Spu/AxCommodityLibrary',
        // parms: `id=${this.copyId}`,
        parmsJson: {
          spuId: this.copyId,
          pageIndex: 1,
          pageSize: 10
        }
      }
      KSAXApiRequest(data).then(res => {
        let object = res.data.response.data[0] || {}
        // this.goodDetailForm = object
        this.goodDetailForm.businessPics = object.businessPics
        this.goodDetailForm.description = object.description
        this.goodDetailForm.modelCode = object.modelCode
        this.goodDetailForm.proContent = object.proContent
        this.goodDetailForm.proName = object.proName
        if (object.brandName) {
          this.brandmodelData.name = object.brandName
          this.goodDetailForm.brandId = object.brandId;
          // 根据商城 品牌名称 查询 erp 对应的 品牌名称  品牌Id
          // let brandItem = this.brandmodelData.restaurants.filter(Item => Item.value === object.brandName)
          // if (brandItem && brandItem.length > 0) {
          // this.goodDetailForm.brandName = brandItem[0].value;
          // this.brandmodelData.name = brandItem[0].value
          // this.goodDetailForm.brandId = brandItem[0].id;
          // }
        }
        if (this.productNavTypeTreeList.length > 0) {
          let typeIds = object.typeIds.split(',')
          typeIds = typeIds.map(Number)
          let typeId = typeIds[typeIds.length - 1] || null
          console.log('typeIds', typeIds, typeId)
          this.goodDetailForm.typeIdList = typeIds ? typeIds : []
          this.goodDetailForm.typeId = typeId || null
          // let typeNames = object.typeName.split('/')
          // let typeName = typeNames[typeNames.length - 1] || null
          // let treeData = this.productNavTypeTreeList
          // let categoryId1 = null, categoryId2 = null
          // if (typeId) {
          //   categoryId1 = this.findParentsByName(treeData, typeId, 'value')
          //   this.goodDetailForm.categoryId = categoryId1 ? categoryId1 : null
          //   this.findAllParents(treeData, categoryId1)
          // }
          // if (typeName && !categoryId1) {
          //   categoryId2 = this.findParentsByName(treeData, typeName, 'label')
          //   this.goodDetailForm.categoryId = categoryId2 ? categoryId2 : null
          //   this.findAllParents(treeData, categoryId2)
          // }
        }
      })
    },
    billPriceInput() {
      this.oneSkuList[0].billPrice = this.oneSkuList[0].billPrice.replace(/[^\d]\d*/g, '')
    },
    billPriceChange() {
      if (this.priceType == 1 && this.supType == 1) {
        this.oneSkuList[0].merchantPrice = (this.oneSkuList[0].billPrice / 0.985).toFixed(2)
        this.oneSkuList[0].customerPrice = (this.oneSkuList[0].billPrice / 0.95).toFixed(2)
        this.oneSkuList[0].marketPrice = (this.oneSkuList[0].billPrice / 0.93).toFixed(2)
      } else {
        this.oneSkuList[0].merchantPrice = this.oneSkuList[0].billPrice
        this.oneSkuList[0].customerPrice = this.oneSkuList[0].billPrice
        this.oneSkuList[0].marketPrice = this.oneSkuList[0].billPrice
      }
    },
    billPriceInput2(row) {
      row.billPrice = row.billPrice.replace(/[^\d]\d*/g, '')
    },
    billPriceChange2(row) {
      row.billPrice = row.billPrice.replace(/[^\d]\d*/g, '')
      if (this.priceType == 1 && this.supType == 1) {
        row.merchantPrice = (row.billPrice / 0.985).toFixed(2)
        row.customerPrice = (row.billPrice / 0.95).toFixed(2)
        row.marketPrice = (row.billPrice / 0.93).toFixed(2)
      } else {
        row.merchantPrice = row.billPrice
        row.customerPrice = row.billPrice
        row.marketPrice = row.billPrice
      }
    },
    getOuthouseCode() {
      let data = {
        stockName: '安得',
        level: 2,
        pageIndex: 1,
        pageSize: 100
      }
      Product_MultistageStockList(data).then(res => {
        if (res.data.success) {
          this.outCodeList = res.data.response.data || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleProvince(e) {
      console.log('e', e);
      this.provinceId = e.Id;
      this.andeForm.SenderProvinceName = e.AreaName;
      this.cityId = null;
      this.andeForm.SenderCityName = null;
      this.districtId = null;
      this.andeForm.SenderDistrictName = null;
      this.townId = null;
      this.andeForm.SenderTownName = null;
      this.getCityList();
    },
    handleCity(e) {
      this.cityId = e.Id;
      this.andeForm.SenderCityName = e.AreaName;
      this.districtId = null;
      this.andeForm.SenderDistrictName = null;
      this.townId = null;
      this.andeForm.SenderTownName = null;
      this.getDistrictList();
    },
    handleArea(e) {
      this.districtId = e.Id;
      this.andeForm.SenderDistrictName = e.AreaName;
      this.townId = null;
      this.andeForm.SenderTownName = null;
      this.getTownList()
    },
    handleTown(e) {
      this.townId = e.Id
      this.andeForm.SenderTownName = e.AreaName;
    },
    //获取省
    getProvinceList() {
      let params = {
        areaLevel: 1,
      };
      areaList(params).then((res) => {
        this.provinceList = res.data.response.data;
      });
    },
    getCityList() {
      // 市
      let that = this;
      let params = {
        areaLevel: 2,
        parentId: this.provinceId,
      };
      areaList(params).then((res) => {
        console.log('res', res);
        this.cityList = res.data.response.data;
        console.log('this.cityList', this.cityList)
        if (this.AdvantageAreaCityId) {
          that.getAreaList();
        }
      });
    },
    getDistrictList() {
      // 区
      let that = this;
      let params = {
        areaLevel: 3,
        parentId: this.cityId,
      };
      areaList(params).then((res) => {
        this.districtList = res.data.response.data;
        console.log('this.districtList', this.districtList)
      });
    },
    getTownList() {
      // 区
      let that = this;
      let params = {
        areaLevel: 4,
        parentId: this.districtId,
      };
      areaList(params).then((res) => {
        this.townList = res.data.response.data;
        console.log('this.districtList', this.districtList)
      });
    },
    pushInfo(row) {
      let data = {
        spuId: row.SpuId,
        skuId: row.Id
      }
      PushSkuToANNTO(data).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    setValue(val) {
      console.log('value', val);
      this.oneSkuList[0].orderRebate = val
    },
    changeType(val) {
      if (val == 0) {
        this.$set(this.goodDetailForm, 'promoteRule', '');
        this.goodDetailForm.promoteRule = ''
      }
      if (val == 1) {
        this.$set(this.goodDetailForm, 'promoteRule', '此商品为预售商品，预计预售结束时间左右到仓可发，具体以实际为准，急单慎拍！');
        // this.goodDetailForm.promoteRule ='此商品为预售商品，预计预售结束时间左右到仓可发，具体以实际为准，急单慎拍！'
      }
      if (val == 2) {
        this.$set(this.goodDetailForm, 'promoteRule', '此商品为抢购商品，会存在库存不足抢购失败情况，抢购失败平台将第一时间退回货款，抢购成功商品待抢购结束后发出，具体以实际为准');
        // this.goodDetailForm.promoteRule ='此商品为抢购商品，会存在库存不足抢购失败情况，抢购失败平台将第一时间退回货款，抢购成功商品待抢购结束后发出，具体以实际为准'
      }
    },
    catchDetailData1(data) {
      this.goodDetailForm.sellingPoint = data;
    },
    catchDetailData4(data) {
      this.goodDetailForm.promoteRule = data;
    },
    catchDetailData3(data) {
      this.goodDetailForm.orderNotice = data;
    },
    catchDetailData2(data) {
      this.goodDetailForm.applicablePeople = data;
    },
    async querySearchAsyncArea(queryString, cb) {
      if (queryString) {
        let res = await this.getAreaList(queryString)
        cb(res);
      } else {
        let res = await this.getAreaList()
        cb(res);
      }
    },
    handleSelectArea(item) {
      this.goodDetailForm.areaLimtId = item.id
    },
    handleClearArea() {
      this.goodDetailForm.areaLimtId = null
      this.goodDetailForm.areaLimtName = null
    },
    showModel() {
      this.selectModelData = {
        id: null,
        modelCode: null,
        disabled: false
      }
      this.modelVisible = true
    },
    handleModelCodeSelect(e) {
      // 获取模板
      this.selectModelData = {
        id: e.id,
        modelCode: e.value,
        disabled: true
      }
      // this.getModelCodeDetail(e.id)
    },
    getModelCodeDetail(id, type, cb) {
      let data = {
        path: 'Product_SpuModel/GetDetail',
        parms: `id=${id}`
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          let {
            modelCode,
            brandId,
            brandName,
            businessPics,
            customerPics,
            proContent,
            typeId,
            typeIds,
            typeName,
            applicablePeople,
            sellingPoint,
            parameters,
            seriesName,
            simpleSellingPoint
          } = res.data.response
          this.goodDetailForm.modelCode = modelCode
          this.goodDetailForm.seriesName = seriesName
          this.goodDetailForm.simpleSellingPoint = simpleSellingPoint
          if (type == 2) {
            this.goodDetailForm.parameters = parameters || []
            this.goodDetailForm.brandId = brandId || null
            this.goodDetailForm.sellingPoint = sellingPoint
            this.goodDetailForm.applicablePeople = applicablePeople
            this.brandmodelData.name = brandName || ''
            this.formatBusinessPics(res.data.response.businessPicsModel || [])
            this.formatCustomerPics(res.data.response.customerPicsModel || [])
            // this.goodDetailForm.businessPics = (businessPics || []).map(i => {
            //   return { spuPicUrl: i }
            // })
            // this.goodDetailForm.customerPics = (customerPics || []).map(i => {
            //   return { spuPicUrl: i }
            // })
            this.goodDetailForm.proContent = proContent || ''
            this.goodDetailForm.typeIdList = typeIds ? typeIds.split(',').map(i => Number(i)) : []
            this.goodDetailForm.typeId = typeId || null
          }
          cb()
          this.updateProName()
        } else {
          this.$message.error(res.data.msg)
        }
        this.modelVisible = false
      });
    },
    handleSelectModel(type) {
      if (!this.selectModelData.id) return this.$message.error("请选择型号");
      this.isDisbaled = true;
      this.getModelCodeDetail(this.selectModelData.id, type, () => {
        this.goodDetailForm.modelCode = this.selectModelData.modelCode;
        this.isDisbaled = false;
        // 重新计算商品名称
        setTimeout(() => {
          this.handleSelType(this.goodDetailForm.typeIdList)
          // if (this.goodDetailForm.typeIdList.length) {
          //   // 获取选择的品类名称
          //   this.getTypeName(this.productNavTypeTreeList)
          //   this.getEntireTypeNameString()
          // }
          // this.getProName()
        }, 200)
      });
    },
    getEntireTypeNameString() {
      this.typeST = setTimeout(() => {
        if (this.$refs.type_cascader) {
          setTimeout(() => {
            this.typeNameString = this.$refs.type_cascader.getCheckedNodes()[0].pathLabels.join(",");
            clearTimeout(this.typeST)
          }, 300)
        } else {
          this.getEntireTypeNameString()
        }
      }, 100)
    },
    reSelect() {
      this.selectModelData = {
        id: null,
        modelCode: null,
        disabled: false
      }
    },
    querySearch(queryString, cb) {
      if (this.getSimpleList_ST) {
        window.clearTimeout(this.getSimpleList_ST)
      }
      this.getSimpleList_ST = setTimeout(() => {
        this.queryModelCodeData(queryString, cb);
      }, 800)
    },
    async queryModelCodeData(queryString, cb) {
      var restaurants = this.restaurants;
      if (queryString) {
        let data = {
          path: 'Product_SpuModel/GetSimpleList',
          parms: '',
          parmsJson: {
            modelCode: queryString
          }
        }
        let res = await KSAXApiRequest(data)
        if (res.data.success) {
          restaurants = res.data.response.map(i => {
            return {
              value: i.modelCode,
              id: i.id,
            }
          })
        }
      }
      cb(restaurants);
    },
    async closeCome(row) {
      if (row) {
        this.detail = { ...row };
      }
      if (this.detail) {
        console.log('detail', this.detail);
        const { Name, DescPics, Desc, PicUrl, realPicUrl } = this.detail;
        this.goodDetailForm.proName = Name;
        this.goodDetailForm.businessPics.push({ isHome: false, isMain: false, spuPicUrl: `${realPicUrl}` });
        console.log('this.goodDetailForm.businessPics', this.goodDetailForm.businessPics)
        this.goodDetailForm.customerPics.push({
          isClientShare: false,
          isHome: false,
          isMain: false,
          spuPicUrl: `${realPicUrl}`
        })
        console.log('this.goodDetailForm.customerPics', this.goodDetailForm.customerPics)
        if (DescPics) {
          let html = '';
          DescPics.forEach((item, index) => {
            console.log('item', item)
            html += `<img src="${item}" alt="">`
          })
          this.goodDetailForm.proContent = html;
        }
        if (Desc) {
          let content = await this.getContentAsync(Desc);
          console.log('content', content);
          // this.form.detailPic = content;
          // this.goodDetailForm.proContent = content
          let html = '';
          content.forEach((item, index) => {
            console.log('item', item)
            html += `<div> <img src="${item}" alt=""> </div>`
          })
          console.log('html', html);
          this.goodDetailForm.proContent = html;
          // console.log('this.goodDetailForm.proContent', this.goodDetailForm.proContent)
        }
        this.oneSkuList[0].skuPicUrl = `${realPicUrl}`
        // console.log(Name, DescPics, Desc, PicUrl)
        this.ComeCome = false;
      }
    },
    getContentAsync(Desc) {
      return new Promise((resolve, reject) => {
        if (!Desc) {
          resolve("");
          return;
        }
        let url = [];
        try {
          // url = this.detail.Desc.match(/(http:\/\/)([\s\S]*)(.css)/)
          // url = this.detail.Desc.match(/(href=\"http:\/\/)([\s\S]*)(.css)/);
          url = Desc.match(/(href=\"http:\/\/)([\s\S]*)(.css)/);
        } catch (e) {
          console.log(e);
        }
        if (url && url.length) {
          if (this.newContent) {
            resolve(this.newContent);
          } else {
            // 京东万商商品详情
            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
              if (this.readyState === 4) {
                if (this.response) {
                  let regexp = /img30.360buyimg.com(\/([\d\w])*)*.(jpg|png|jpeg)\);\s(height:(\d*))px/gi;
                  let matches = this.response.match(regexp);
                  if (matches && matches.length) {
                    let html = "";
                    matches.forEach((i) => {
                      html += `<img src="https://${i.split(");")[0]
                        }" style="width:750px;height:${i.split("height:")[1]}">`;
                    });
                    this.newContent = `<div>${html}</div>`;
                    resolve(this.newContent);
                  } else {
                    this.newContent = "";
                    resolve(this.newContent);
                  }
                } else {
                  resolve("");
                }
              } else {
                resolve("");
              }
            };
            xhr.open("get", url[0].replace('href="', ""), true);
            xhr.send();
          }
        } else {
          // const content = this.detail.Desc;
          const content = Desc;
          if (content.indexOf("ssd-module-wrap") > -1) {
            // 含有这种ssd-module-wrap格式的京东商品
            const regix = /\/\/img[0-9]*.360buyimg.com(\/([\d\w])*)*.(jpg|png|jpeg)/gi;
            // const regix = /\/\/img30.360buyimg.com(\/([\d\w])*)*.(jpg|png|jpeg)/gi;
            // let regix = /img[0-9]*.360buyimg.com(\/([\d\w])*)*.(jpg|png|jpeg)\);\s(height:(\d*))px/gi;
            const imgs = content.match(regix);
            console.log('imgs', imgs);
            let url = [];
            imgs.forEach((i) => {
              url.push(i);
            });

            resolve(url);
          } else {
            resolve(content);
          }
        }
      });
    },
    async getJDProduct() {
      this.ComeCome = true;
      // let params = {PageIndex:1, pageSize:30}
      // let res = await JDProductSearch(params);
      // console.log('jd', res);
    },
    addSeries() {
      let { href } = this.$router.resolve({
        path: `/Product/ComManagement/SeriesGoods`,
      });
      window.open(href, "_blank");
    },
    hideVedio() {
      this.showVideo = false
    },
    delPic(i, index) {
      this.videoUrl = '';
    },
    playFromSucao(url) {
      this.showVideo = true
    },
    handleChange(file, i) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        // if (i === 7) {  // 大牌视频   图片上传
        // let flag = this.getVideoType(file);
        // if (!flag) {
        //   return this.$message.error('视频格式或者大小有误(只支持mp4格式,大小20M之内)');
        // }
        that.videoUrl = (res);
        // }
      }).catch((err) => {
        that.$message.error(err);
      });
    },
    changeIsPreSale(val) {
      if (!val) {
        this.goodDetailForm.preSaleDescribe = ''
      }
    },
    clearPrice(val) {
      if (val === false) {
        this.goodDetailForm.skus[0].strikePrice = null;
      }
    },
    changeCoupon(val) {
      if (val == true) {
        this.getCouponList()
      } else {
        this.goodDetailForm.giftCouponIds = []
      }
    },
    getCouponList() {
      let params = {
        AuditStatus: 2,
        pageIndex: 1,
        pageSize: 100
      }
      couponList(params).then(res => {
        this.couponList = res.data.response.data || []
      })
    },
    catchData(data) {
      this.goodDetailForm.description = data;
    },
    catchDetailData(data) {
      this.goodDetailForm.proContent = data;
    },
    formatBusinessPics(list = []) {
      // 深拷贝
      let pics = JSON.parse(JSON.stringify(list))
      // 固定类型
      const fixedTypes = [1, 2, 3, 4, 5, 6]
      // 判断是否存在固定类型
      const hasFixedType = pics.some(item =>
        fixedTypes.includes(item.type)
      )
      // 如果一个固定类型都没有
      if (!hasFixedType && pics.length) {
        pics[0].type = 3
      }
      // 固定图片
      const fixedList = []
      fixedTypes.forEach(type => {
        const target = pics.find(item => item.type === type)
        if (target) {
          fixedList.push(target)
        } else {
          // 补空对象
          fixedList.push({
            type: type,
            spuPicUrl: '',
            isMain: false,
            isHome: false
          })
        }
      })
      // 非固定图片
      const otherList = pics.filter(
        item => !fixedTypes.includes(item.type)
      )
      // 最终结果
      this.goodDetailForm.businessPics = [
        ...fixedList,
        ...otherList
      ]
    },
    formatCustomerPics(list = []) {
      // 深拷贝
      let pics = JSON.parse(JSON.stringify(list))
      // 固定类型
      const fixedTypes = [3, 4, 5, 6]
      // 判断是否存在固定类型
      const hasFixedType = pics.some(item =>
        fixedTypes.includes(item.type)
      )
      // 固定图片
      const fixedList = []
      fixedTypes.forEach(type => {
        const target = pics.find(item => item.type === type)
        if (target) {
          fixedList.push(target)
        } else {
          // 补空对象
          fixedList.push({
            type: type,
            spuPicUrl: '',
            isMain: false,
            isHome: false
          })
        }
      })
      // 非固定图片
      const otherList = pics.filter(
        item => !fixedTypes.includes(item.type)
      )
      // 最终结果
      this.goodDetailForm.customerPics = [
        ...fixedList,
        ...otherList
      ]
    },
    //获取商品详情数据
    getProductSpuDetail() {
      let that = this;
      if (that.spuId) {
        var params = {
          // spuId: that.spuId,
          "path": "Product_Spu/Detail",
          "parms": `spuId=${that.spuId}`,
          "parmsJson": null
        };
        KSAXApiRequest(params).then((res) => {
          // productSpuDetail(params).then((res) => {
          that.videoUrl = res.data.response.videoPath;
          // 临时添加判断是不是所属供应商列表里，不是禁止修改后返价格
          // res.data.response.disabledMinAfterPrice = !isInSupplyerList(res.data.response.supId),
          // res.data.response.skus.forEach(item => {
          //   item.afterPrice = isInSupplyerList(res.data.response.supId) ? item.afterPrice : 0
          // })
          that.supType = res.data.response.supType
          that.goodDetailForm = res.data.response;
          that.goodDetailForm.jargonIds = res.data.response.jargonIds ? res.data.response.jargonIds.split(",") : []
          that.formatBusinessPics(res.data.response.businessPics || [])
          that.formatCustomerPics(res.data.response.customerPics || [])
          that.getKeyWordData()
          that.getGargonData()
          setTimeout(() => {
            that.isFirstLoad = false
          }, 1000);
          that.isBusinessLimit =
            res.data.response.isBusinessAccountLimit ||
            res.data.response.isBusinessBuyNumLimit;
          that.goodDetailForm.seriesName = that.goodDetailForm.seriesName2
          if (!that.goodDetailForm.seriesName || !that.goodDetailForm.simpleSellingPoint) {
            that.product_SpuModelGetSimpleList()
          }
          if (that.goodDetailForm.deliveryTimeTag == null) {
            that.goodDetailForm.deliveryTimeTag = 0
          }
          //
          if (that.goodDetailForm.promoteTag == '0') {
            that.goodDetailForm.promoteRule = ''
          }
          if (that.goodDetailForm.promoteTag == '1' && !that.goodDetailForm.promoteRule) {
            that.goodDetailForm.promoteRule = '此商品为预售商品，预计预售结束时间左右到仓可发，具体以实际为准，急单慎拍！'
          }
          if (that.goodDetailForm.promoteTag == '1' && (!that.goodDetailForm.promoteDeliveryTimeTag || that.goodDetailForm.promoteDeliveryTimeTag == 0)) {
            return that.$message.error('请选择活动结束后发货时效!')
          }
          if (that.goodDetailForm.promoteTag == '2' && !that.goodDetailForm.promoteRule) {
            that.goodDetailForm.promoteRule = '此商品为抢购商品，会存在库存不足抢购失败情况，抢购失败平台将第一时间退回货款，抢购成功商品待抢购结束后发出，具体以实际为准'
          }
          if (that.goodDetailForm.promoteTag == '2' && (!that.goodDetailForm.promoteDeliveryTimeTag || that.goodDetailForm.promoteDeliveryTimeTag == 0)) {
            return that.$message.error('请选择活动结束后发货时效!')
          }
          if (Number(that.goodDetailForm.minBuyNum) == 0) {
            that.goodDetailForm.minBuyNum = 1;
          }
          if (Number(that.goodDetailForm.minCustomerBuyNum) == 0) {
            that.goodDetailForm.minCustomerBuyNum = 1;
          }
          that.goodDetailForm.description = res.data.response.description;
          that.goodDetailForm.proContent = res.data.response.proContent;
          that.goodDetailForm.isHasClientGift = res.data.response.isHasClientGift;
          that.StandardRate = res.data.response.StandardRate || 0;
          if (!res.data.response.tagList) {
            res.data.response.tagList = []
          }
          if (
            res.data.response.isCustomerAccountLimit ||
            res.data.response.isCustomerBuyNumLimit
          ) {
            that.activeCName = res.data.response.isCustomerAccountLimit
              ? "first"
              : "second";
          }
          if (
            res.data.response.isBusinessAccountLimit ||
            res.data.response.isBusinessBuyNumLimit
          ) {
            that.activeBName = res.data.response.isBusinessAccountLimit
              ? "first"
              : "second";
          }
          if (res.data.response.isSingleSpec) {
            if (!res.data.response.skus[0]) {
              that.goodDetailForm.skus = [
                {
                  skuPicUrl: null,
                  supSkuCode: null,
                  defaultStock: null,
                  costPrice: 0,
                  marketPrice: 0,
                  customerPrice: 0,
                  merchantPrice: null,
                  billPrice: 0,
                  thirdPrice: 0,
                  areaStocks: [],
                  strikePrice: null,
                  performanceFee: null,
                  skuSpecs: null
                },
              ];
              // 单规格是否显示到手价
              if (that.goodDetailForm.skus[0].strikePrice === '' || that.goodDetailForm.skus[0].strikePrice === null) {
                that.isStrickPriceShow = false;
              } else {
                that.isStrickPriceShow = true;
              }

            } else {
              console.log('res.data.response.skus 单规格', res.data.response.skus)
              if (that.goodDetailForm.skus[0].isInstallSubsidy) {
                that.goodDetailForm.skus[0].orderRebate = that.goodDetailForm.skus[0].installSubsidyVal
              }
              that.oneSkuList = res.data.response.skus;
              // 单规格是否显示到手价  根据是否有到手价
              if (that.goodDetailForm.skus[0].strikePrice === '' || that.goodDetailForm.skus[0].strikePrice === null) {
                that.isStrickPriceShow = false;
              } else {
                that.isStrickPriceShow = true;
              }
            }
          } else {
            that.createSkuList = res.data.response.skus;
            console.log(that.createSkuList)
            that.oneSkuList = JSON.parse(
              JSON.stringify(res.data.response.skus.slice(0, 1))
            );
          }
          that.brandmodelData.name = res.data.response.brandName;
          that.supmodelData.name = res.data.response.supName;
          if (!res.data.response.properties) {
            res.data.response.properties = []
          }
          let properties = res.data.response.properties || [];
          let typeArr = res.data.response.typeIdList;
          this.getEntireTypeNameString()
          // let params = {
          //   path: 'Product_Type/GetByTypeId',
          //   parmsJson: {
          //     typeId: typeArr[typeArr.length - 1],
          //   }
          // };
          // //参数类型赋值
          // KSAXApiRequest(params).then((res) => {
          //   if (res.data.success) {
          //     // 添加一个自定义属性
          //     if (res.data.response && res.data.response.length) {
          //       res.data.response.forEach((i) => {
          //         i.extendPropertyValue = "";
          //       });
          //     }
          //     that.paramsTypeList = res.data.response || [];
          //     that.paramsTypeList.forEach((v, i) => {
          //       if (v.propertyType == 10) {
          //         that.$set(that.paramsTypeAddList, i, null);
          //       } else {
          //         that.$set(that.paramsTypeAddList, i, []);
          //       }
          //     });
          //     if (properties && properties[0]) {
          //       properties.forEach((v, i) => {
          //         let index = that.paramsTypeList.findIndex(
          //           (p) => p.id == v.propertyItemId
          //         );
          //         if (index > -1) {
          //           if (v.propertyType == 10) {
          //             that.$set(that.paramsTypeAddList, index, null);
          //             that.paramsTypeAddList[index] = v.propertyValue;
          //           } else {
          //             // 给自定义属性赋值
          //             that.$set(
          //               that.paramsTypeList[index],
          //               "extendPropertyValue",
          //               v.extendPropertyValue || ""
          //             );
          //             that.$set(that.paramsTypeAddList, index, []);
          //             that.paramsTypeAddList[index] = v.propertyValueIds;
          //           }
          //         }
          //       });
          //     }
          //   }
          // });
          // }
          that.editSetParams();
          if (res.data.response.isOrderGiftCoupon) {
            this.getCouponList()
          }
          if (this.isGetReturnMemberRebateConfig) {
            this.GetReturnMemberRebateConfig()
          }
        });
      }
    },
    //编辑设置规格参数
    editSetParams() {
      let that = this;
      if (that.createSkuList[1]) {
        let skulist = that.createSkuList[0].skuSpecs.split(",");
        let specs = [];
        let specsSku = [];
        let specsSkuIdList = [];
        skulist.forEach((v, i) => {
          specs.push(v.split(":")[0]);
        });
        specs.forEach((v, i) => {
          that.restaurantsSpe.forEach((v1, i1) => {
            if (v == v1.id) {
              let params = {
                path: 'Product_SpecValue/List',
                parms: '',
                parmsJson: {
                  pageIndex: 1,
                  pageSize: 100,
                  specId: v1.id,
                }
              };
              KSAXApiRequest(params).then((res) => {
                that.selAllSpec[i] = {
                  label: v1.specName,
                  data: res.data.response.data,
                  selScepIds: [],
                };
                that.selAllSpec.forEach((v, i) => {
                  that.selectScepIds[i] = v.data[0].specId; // 判断当前规格是否已添加
                  v.selScepIds = specsSkuIdList[i]; // checkbox已勾选的规格
                });
                that.$forceUpdate();
              });
            }
          });
        });
        that.createSkuList.forEach((v, i) => {
          specsSku[i] = v.skuSpecs.split(",");
        });
        specsSku[0].forEach((v, i) => {
          specsSkuIdList[i] = [];
        });
        specsSku.forEach((v, i) => {
          v.forEach((v1, i1) => {
            let isBe = specsSkuIdList[i1].indexOf(Number(v1.split(":")[1])); // 帅选出添加数据返回的checkbox数据 ---> 去重
            if (isBe == -1) {
              specsSkuIdList[i1].push(Number(v1.split(":")[1]));
            }
          });
        });
      }
    },
    getProductNavTypeTree() {
      // productNavTypeTree
      let data = {
        path: 'Product_Type/TreeList',
        parms: '',
        parmsJson: null
      }
      KSAXApiRequest(data).then((res) => {
        this.productNavTypeTreeList = res.data.response;
        if (this.$route.query.copyid && this.productNavTypeTreeList.length > 0) {
          this.getCopySpuData()
        }
        this.$nextTick(() => {
          // 添加这段代码
          const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
          Array.from($el).map((item) => item.removeAttribute('aria-owns'));
        });
      });
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    // 获取品牌列表
    getBrandList(e) {
      let that = this;
      let params = {
        path: 'Product_Brand/list',
        parms: '',
        parmsJson: {
          pageIndex: 1,
          pageSize: 100,
          brandName: e ? e : "",
        }
      }
      KSAXApiRequest(params).then((res) => {
        let list = [];
        res.data.response.data.forEach((v, i) => {
          list[i] = {
            value: v.brandName,
            id: v.id,
          };
        });
        that.brandmodelData.restaurants = list;
      });
    },
    //获取供应商列表
    getBusSupplierList(e) {
      let that = this;
      let params = {
        Name: e ? e : "",
        SkipCount: 0,
        MaxResultCount: 100
      };
      GetAllReseller(params).then((res) => {
        let list = [];
        that.ResellerId = res.data.result.items[0].remoteKey
        that.priceType = res.data.result.items[0].priceType
        if (!that.$route.query.id) {
          that.supmodelData.name = res.data.result.items[0].name;
          that.goodDetailForm.supId = res.data.result.items[0].remoteKey
          that.supType = res.data.result.items[0].supType
        }
        res.data.result.items.forEach((v, i) => {
          list[i] = {
            value: v.name,
            id: v.remoteKey,
            supType: v.supType,
            priceType: v.priceType
          };
        });
        that.supmodelData.restaurants = list;
      });
    },
    handleCClick(tab) {
      if (tab.name == "first") {
        this.goodDetailForm.isCustomerAccountLimit = true;
        this.goodDetailForm.isCustomerBuyNumLimit = false;
      } else {
        this.goodDetailForm.isCustomerAccountLimit = false;
        this.goodDetailForm.isCustomerBuyNumLimit = true;
      }
    },
    handleBClick(tab) {
      if (tab.name == "first") {
        this.goodDetailForm.isBusinessAccountLimit = true;
        this.goodDetailForm.isBusinessBuyNumLimit = false;
      } else {
        this.goodDetailForm.isBusinessAccountLimit = false;
        this.goodDetailForm.isBusinessBuyNumLimit = true;
      }
    },
    //获取限购模板列表
    getAreaList(key) {
      let obj = {
        path: 'Product_AreaLimit/list',
        parms: '',
        parmsJson: {
          supId: this.ResellerId,
          pageIndex: 1,
          pageSize: 100
        }
      }
      if (key) {
        obj.parmsJson.AreaLimitName = key
      }
      return new Promise((resolve, reject) => {
        KSAXApiRequest(obj).then((res) => {
          if (res.data.success) {
            this.restaurantsArea = res.data.response.data.map(item => {
              return {
                value: item.areaLimitName,
                id: item.id
              }
            })
            resolve(this.restaurantsArea)
          } else {
            this.$message.error(res.data.msg)
            reject(res.data.msg)
          }
        });
      })
    },
    //获取规格列表
    getSpecList() {
      let that = this;
      let para = {
        path: 'Product_Spec/list',
        parms: '',
        parmsJson: {
          page: this.pageIndex,
        }
      };
      KSAXApiRequest(para).then((res) => {
        that.restaurantsSpe = [
          ...that.restaurantsSpe,
          ...res.data.response.data,
        ];
        if (that.pageIndex >= res.data.response.pageCount) {
          that.pageIndex = res.data.response.pageCount;
          that.flag = true;
        }
      });
    },
    remoteMethod(e, cb) {
      let param = {
        path: 'Product_Spec/list',
        parms: `page=1&key=${e}`,
        // parmsJson: {
        //   page: 1,
        //   key: e ? e : "",
        // }
      };
      KSAXApiRequest(param).then((res) => {
        this.restaurantsSpe = res.data.response.data;
        cb && cb()
      });
    },
    loadMore() {
      if (this.flag) {
        this.$message.error("没有数据了！");
        return false;
      }
      this.pageIndex++;
      this.getSpecList();
    },
    //选择类型后匹配参数
    handleSelType(typeArr) {
      console.log('typeArr', typeArr)
      let that = this;
      let params = {
        path: 'Product_Type/GetByTypeId',
        parmsJson: {
          typeId: typeArr[typeArr.length - 1],
        }
      };
      // 获取选择的分类名称
      this.getTypeName(this.productNavTypeTreeList)
      this.getEntireTypeNameString()
      KSAXApiRequest(params).then((res) => {
        if (res.data.success) {
          if (res.data.response[0]) {
            that.paramsTypeList = res.data.response;
            that.paramsTypeAddList = []
            that.goodDetailForm.properties = []
            res.data.response.forEach((v, i) => {
              if (v.propertyType == 10) {
                that.$set(that.paramsTypeAddList, i, null);
                that.goodDetailForm.properties[i] = {
                  propertyGroupId: v.propertyGroupId,
                  propertyType: v.propertyType,
                  propertyItemId: v.id,
                  propertyValue: "",
                };
              } else {
                that.$set(that.paramsTypeAddList, i, []);
                that.goodDetailForm.properties[i] = {
                  propertyGroupId: v.propertyGroupId,
                  propertyType: v.propertyType,
                  propertyItemId: v.id,
                  propertyValueIds: [],
                };
              }
            });
          } else {
            that.goodDetailForm.properties = [];
            that.paramsTypeAddList = [];
            that.paramsTypeList = []
          }
        } else {
          that.$message.error(res.data.msg);
        }
        // 重新获取商品名称
        this.getProName()
      });
      // 厨卫大电/燃气灶
      if (typeArr.length === 2 && typeArr[0] === 85 && typeArr[1] === 89 && !this.$route.query.id) {
        this.goodDetailForm.isSingleSpec = false
        this.remoteMethod("燃气灶", () => {
          if (this.restaurantsSpe.filter(item => item.specName === "燃气灶").length === 1) {
            this.selectScepId = this.restaurantsSpe.filter(item => item.specName === "燃气灶")[0].id
            this.selectScep(() => {
              this.$nextTick(() => {
                this.selAllSpec.forEach(item => {
                  item.selScepIds = item.data.map(i => {
                    return i.id
                  })
                })
                this.$nextTick(() => {
                  this.selCheckboxFun()
                });
              });
            })
          }
        })
      }
    },
    bindParamsInput(e, index) {
      if (this.goodDetailForm.properties[index]) {
        this.goodDetailForm.properties[index].propertyValue = e;
      } else {
        let obj = {
          propertyGroupId: this.paramsTypeList[index].propertyGroupId,
          propertyType: this.paramsTypeList[index].propertyType,
          propertyItemId: this.paramsTypeList[index].id,
          propertyValue: e,
        }
        this.goodDetailForm.properties.push(obj)
      }
      this.getProName()
    },
    // 验证名称里是否含有选定参数
    valideProperty(cb) {
      // 没有规格 通过
      if (!this.paramsTypeList.length) {
        if (cb) {
          return cb([])
        }
        return true;
      }
      let propertyNameArr = [];
      // 先获取所有数组中的PropertyValues
      let pVs = [];
      this.paramsTypeList.forEach((item) => {
        pVs = pVs.concat(item.propertyValues);
        // 如果自定义ExtendPropertyValue有值，存入
        if (item.extendPropertyValue) {
          propertyNameArr.push(item.extendPropertyValue);
        }
        // 1. 验证逻辑： 改成从所有参数里验证，不管是否选中
        if (!cb) {
          item.propertyValues.forEach(sub => {
            propertyNameArr.push(sub.propertyValue);
          })
          let inputV = this.goodDetailForm.properties.find(i => i.propertyType == 10)
          if (inputV && inputV.propertyValue) {
            propertyNameArr.push(inputV.propertyValue);
          }
        }
      });
      // 2. 添加商品时，获取选中的以备自动填充
      if (cb) {
        this.goodDetailForm.properties.forEach((i) => {
          if (i.propertyType == 10) {
            // 输入的
            i.propertyValue && propertyNameArr.push(i.propertyValue);
          } else {
            // 单选或多选的
            if (i.propertyValueIds.length) {
              i.propertyValueIds.forEach((id) => {
                let tar = pVs.find((i) => i.id == id);
                if (tar) {
                  propertyNameArr.push(tar.propertyValue); // 把名字插入数组
                }
              });
            }
          }
        });
      }
      if (cb) {
        // 这里只做获取参数列表
        return cb(propertyNameArr)
      }
      let bool = false;
      console.log(propertyNameArr)
      for (var i = 0; i < propertyNameArr.length; i++) {
        if (this.goodDetailForm.proName.indexOf(propertyNameArr[i]) > -1) {
          bool = true;
          break;
        }
      }
      return bool;
    },
    // 用于新添加商品时计算商品标题方法
    getProName() {
      return
      // 编辑的商品不做操作
      // if (this.spuId) return
      this.getTypeName(this.productNavTypeTreeList)
      setTimeout(() => {
        const getR = (arr) => {
          if (!arr.length) {
            return ''
          }
          let index = Math.floor(Math.random() * arr.length);
          return arr[index];
        }
        const brandName = this.brandmodelData.name
        const typeName = this.selTypeName.replace(/\s*/g, "").replaceAll('/', "")
        let properties = []
        this.valideProperty((data) => {
          properties = data
        })
        const modelCode = this.goodDetailForm.modelCode
        let keyWords = []
        this.valideKeyWord(data => {
          keyWords = data
        })
        this.goodDetailForm.proName = `${brandName || ''}${typeName || ''}${modelCode || ""}${properties.join(' ')}${keyWords.filter(i => i).join(' ')}`
      }, 200)
    },
    bindParamsRadio(e, index) {
      // 单选切换时清空自定义值
      this.$set(this.paramsTypeList[index], "extendPropertyValue", "");
      if (this.goodDetailForm.properties[index]) {
        this.goodDetailForm.properties[index].propertyValueIds[0] = e;
        this.goodDetailForm.properties[index].extendPropertyValue = "";
      } else {
        let obj = {
          propertyGroupId: this.paramsTypeList[index].propertyGroupId,
          propertyType: this.paramsTypeList[index].propertyType,
          propertyItemId: this.paramsTypeList[index].id,
          propertyValueIds: e != 0 ? [e] : [],
          extendPropertyValue: "",
        };
        this.goodDetailForm.properties.push(obj);
      }
      this.getProName()
    },
    onParamsInputChange(val, index, id) {
      let pIndex = this.goodDetailForm.properties.findIndex((i) => i.propertyItemId == id);
      if (pIndex > -1) {
        this.$set(
          this.goodDetailForm.properties[index],
          "extendPropertyValue",
          val
        );
        this.$set(
          this.goodDetailForm.properties[pIndex],
          "propertyValueIds",
          [0]
        );
      } else {
        let obj = {
          propertyGroupId: this.paramsTypeList[index].propertyGroupId,
          propertyType: this.paramsTypeList[index].propertyType,
          propertyItemId: this.paramsTypeList[index].id,
          propertyValueIds: [0],
          extendPropertyValue: val,
        };
        this.goodDetailForm.properties.push(obj);
      }
      this.getProName()
    },
    bindParamsCheckbox(e, index) {
      if (!e.includes(0)) {
        // 清空自定义值
        this.$set(this.paramsTypeList[index], "extendPropertyValue", "");
      }
      let arr = e.slice();
      // if (e.includes(0)) {
      //   arr.pop() // 挤出0
      // }
      if (this.goodDetailForm.properties[index]) {
        this.goodDetailForm.properties[index].propertyValueIds = arr;
      } else {
        let obj = {
          propertyGroupId: this.paramsTypeList[index].propertyGroupId,
          eropertyType: this.paramsTypeList[index].propertyType,
          eropertyItemId: this.paramsTypeList[index].id,
          eropertyValueIds: arr,
          extendPropertyValue: "",
        };
        this.goodDetailForm.properties.push(obj);
      }
      this.getProName()
    },
    handleBigPic(src) {
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    handleDelPic(index, id) {
      let that = this;
      if (id == 1) {
        if (index <= 5) {
          that.goodDetailForm.businessPics[index].spuPicUrl = null
        } else {
          that.goodDetailForm.businessPics.splice(index, 1);
        }
      } else if (id == 2) {
        if (index <= 3) {
          that.goodDetailForm.customerPics[index].spuPicUrl = null
        } else {
          that.goodDetailForm.customerPics.splice(index, 1);
        }
      }
    },
    setShare(index) {
      let that = this;
      that.goodDetailForm.customerPics.forEach((v, i) => {
        if (index != i) {
          v.isClientShare = false;
        } else {
          v.isClientShare = true;
        }
      });
    },
    setHome(index, id) {
      let that = this;
      if (id == 1) {
        that.goodDetailForm.businessPics.forEach((v, i) => {
          if (index != i) {
            v.isHome = false;
          } else {
            v.isHome = true;
          }
        });
      } else if (id == 2) {
        that.goodDetailForm.customerPics.forEach((v, i) => {
          if (index != i) {
            v.isHome = false;
          } else {
            v.isHome = true;
          }
        });
      }
    },
    setMain(index, id) {
      let that = this;
      if (id == 1) {
        that.goodDetailForm.businessPics.forEach((v, i) => {
          v.isMain = false
        })
        that.goodDetailForm.businessPics[index].isMain = true;
      } else if (id == 2) {
        that.goodDetailForm.customerPics.forEach((v, i) => {
          v.isMain = false
        })
        that.goodDetailForm.customerPics[index].isMain = true;
      }
    },
    handleCopy() {
      let list = [];
      const businessPics = this.goodDetailForm.businessPics || []
      // 有图片的数据
      const hasPicList = businessPics.filter(item => item.spuPicUrl)
      // 判断是否只有 type=1、2 有图
      const onlyType12 =
        hasPicList.length > 0 &&
        hasPicList.every(item => [1, 2].includes(item.type))
      if (onlyType12) {
        this.$message.warning('暂无可复制的图片')
        return
      }
      // 复制规则
      this.goodDetailForm.customerPics = businessPics
        .filter(item => {
          // type=1、2 不复制
          if ([1, 2].includes(item.type)) {
            return false
          }
          // type=3、4、5、6 必须保留（即使空）
          if ([3, 4, 5, 6].includes(item.type)) {
            return true
          }
          // 其他类型必须有图片
          return !!item.spuPicUrl
        })
        .map(item => ({
          ...item
        }))
      this.goodDetailForm.businessPics.forEach((v) => {
        if (v.isMain) {
          this.oneSkuList[0].SkuPicUrl = v.spuPicUrl;
        }
      });
    },
    handleCustomerPic(file, index = null) {
      this.imageType = 2
      this.imageIndex = index != null ? index : null;
      this.imageFile = file;
      this.dialogCropperVisible = true
    },
    handleCustomerOtherPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}_${Math.random().toString(36).slice(2)}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic = {
            spuPicUrl: res,
            isMain: false,
            isClientShare: false,
            isHome: false,
            type: 0,
          }
          that.goodDetailForm.customerPics.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleBusinessPic(file, index = null) {
      this.imageType = 1
      this.imageIndex = index != null ? index : null;
      this.imageFile = file;
      this.dialogCropperVisible = true
    },
    handleBusinessOtherPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}_${Math.random().toString(36).slice(2)}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic = {
            spuPicUrl: res,
            isMain: false,
            isHome: false,
            type: 0,
          }
          that.goodDetailForm.businessPics.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleCropSuccess({ blob }) {
      console.log('blob', blob)
      console.log('this.imageIndex', this.imageIndex)
      // return false
      let that = this

      let fileSuf = 'png'
      let qiniuData = {
        key: `KSAX/System/image/${Date.now()}.${fileSuf}`,
        token: that.qiniuToken,
      }
      that.$utils
        .uploadImgToQiniu(blob, qiniuData)
        .then((res) => {
          console.log('res七牛', res)
          if (this.imageType == 1) {
            if (this.imageIndex != null) {
              that.goodDetailForm.businessPics[this.imageIndex].spuPicUrl = res
            } else {
              let itemPic = {
                spuPicUrl: res,
                isMain: false,
                isHome: false,
                type: 0,
              }
              that.goodDetailForm.businessPics.push(itemPic)
            }
          } else if (this.imageType == 2) {
            if (this.imageIndex != null) {
              that.goodDetailForm.customerPics[this.imageIndex].spuPicUrl = res
            } else {
              let itemPic = {
                spuPicUrl: res,
                isMain: false,
                isClientShare: false,
                isHome: false,
                type: 0,
              }
              that.goodDetailForm.customerPics.push(itemPic)
            }
          }

          // 关闭裁剪弹窗
          that.dialogCropperVisible = false
        })
        .catch((err) => {
          that.$message.error(err)
        })
    },
    handleSwitch(e, index) {
      if (e && index == 2) {
        this.goodDetailForm.isBusinessAccountLimit = true;
        this.goodDetailForm.isBusinessBuyNumLimit = false;
      } else if (!e && index == 2) {
        this.goodDetailForm.isBusinessAccountLimit = false;
        this.goodDetailForm.isBusinessBuyNumLimit = false;
      } else if (e && index == 1) {
        this.goodDetailForm.isCustomerAccountLimit = true;
        this.goodDetailForm.isCustomerBuyNumLimit = false;
      } else if (!e && index == 1) {
        this.goodDetailForm.isCustomerAccountLimit = false;
        this.goodDetailForm.isCustomerBuyNumLimit = false;
      }
    },
    handleSkuChange(e, i) {
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file, qiniuData)
        .then((res) => {
          window.document.getElementById("el_upload_input").value = null;
          if (i != null) {
            that.createSkuList[i].skuPicUrl = res;
          } else {
            // that.goodDetailForm.skus[0].skuPicUrl = res;
            that.oneSkuList[0].skuPicUrl = res;
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delSkuPic(i) {
      if (i >= 0) {
        this.createSkuList[i].skuPicUrl = "";
      } else {
        // this.goodDetailForm.skus[0].skuPicUrl = "";
        this.oneSkuList[0].skuPicUrl = "";
      }
    },
    selectScep(cb) {
      let that = this;
      let params = {
        path: 'Product_SpecValue/List',
        parms: '',
        parmsJson: {
          pageIndex: 1,
          pageSize: 100,
          specId: that.selectScepId, // 296,295
        }
      };
      KSAXApiRequest(params).then((res) => {
        let index = that.selectScepIds.indexOf(that.selectScepId);
        if (index == -1) {
          that.restaurantsSpe.forEach((v, i) => {
            if (that.selectScepId == v.id) {
              that.selectScepIds.push(that.selectScepId);
              if (that.selAllSpec.length < 4) {
                that.selAllSpec.push({
                  label: v.specName,
                  data: res.data.response.data,
                  selScepIds: [],
                });
              } else {
                that.$message.error("最多支持4种规格！");
              }
            }
          });
          cb && cb()
        } else {
          that.$message.error("该规格已添加！");
        }
      });
    },
    setArr(arrs) {
      let that = this;
      let _arrs = [];
      arrs[0].list.forEach((v, i) => {
        _arrs.push({
          specName: `${v.specValue}`,
          skuSpecs: `${v.specId}:${v.id}`,
          supSkuCode: "",
          skuPicUrl: "",
          defaultStock: 0,
          costPrice: 0,
          marketPrice: 0,
          customerPrice: 0,
          billPrice: 0,
          thirdPrice: 0,
          merchantPrice: 0,
          areaStocks: [],
          unitRebate: 0,
          monthRebate: 0,
          orderRebate: 0,
          structRebate: 0,
          subsidy: 0,
          highPurchaseAfterRebate: 0,
          strikePrice: null,
          grossProfit: 0,
          isInstallSubsidy: false,
          installSubsidyVal: null,
          skuPicUrl: null
        });
      });
      that.createSkuList = _arrs;
    },
    setArr2(arrs, _arrs) {
      let that = this;
      let __arrs = [];
      arrs.list.forEach((v1, i1) => {
        _arrs.list.forEach((v2, i2) => {
          __arrs.push({
            specName: `${v1.specValue} ${v2.specValue}`,
            skuSpecs: `${v1.specId}:${v1.id},${v2.specId}:${v2.id}`,
            supSkuCode: "",
            skuPicUrl: "",
            defaultStock: 0,
            costPrice: 0,
            marketPrice: 0,
            customerPrice: 0,
            billPrice: 0,
            thirdPrice: 0,
            merchantPrice: 0,
            areaStocks: [],
            unitRebate: 0,
            monthRebate: 0,
            orderRebate: 0,
            structRebate: 0,
            subsidy: 0,
            highPurchaseAfterRebate: 0,
            strikePrice: null,
            grossProfit: 0,
            isInstallSubsidy: false,
            installSubsidyVal: null,
            skuPicUrl: null
          });
        });
      });
      that.createSkuList = __arrs;
    },
    setArr3(arrs1, arrs2, arrs3) {
      let that = this;
      let _arrs = [];
      arrs1.list.forEach((v1, i1) => {
        arrs2.list.forEach((v2, i2) => {
          _arrs.push({
            specName: `${v1.specValue}--${v2.specValue}`,
            skuSpecs: `${v1.specId}:${v1.id},${v2.specId}:${v2.id}`,
            supSkuCode: "",
            skuPicUrl: "",
            defaultStock: 0,
            costPrice: 0,
            marketPrice: 0,
            billPrice: 0,
            thirdPrice: 0,
            customerPrice: 0,
            merchantPrice: 0,
            areaStocks: [],
            unitRebate: 0,
            monthRebate: 0,
            orderRebate: 0,
            structRebate: 0,
            subsidy: 0,
            highPurchaseAfterRebate: 0,
            strikePrice: null,
            grossProfit: 0,
            isInstallSubsidy: false,
            installSubsidyVal: null,
            skuPicUrl: null
          });
        });
      });
      that.setArr4(_arrs, arrs3);
    },
    setArr4(arrs1, arrs2) {
      let that = this;
      let _arrs = [];
      arrs1.forEach((v, i) => {
        arrs2.list.forEach((v2, i2) => {
          _arrs.push({
            specName: `${v.specName}--${v2.specValue}`,
            skuSpecs: `${v.skuSpecs},${v2.specId}:${v2.id}`,
            supSkuCode: "",
            skuPicUrl: "",
            defaultStock: 0,
            costPrice: 0,
            marketPrice: 0,
            billPrice: 0,
            thirdPrice: 0,
            customerPrice: 0,
            merchantPrice: 0,
            areaStocks: [],
            unitRebate: 0,
            monthRebate: 0,
            orderRebate: 0,
            structRebate: 0,
            subsidy: 0,
            highPurchaseAfterRebate: 0,
            strikePrice: null,
            grossProfit: 0,
            isInstallSubsidy: false,
            installSubsidyVal: null,
            skuPicUrl: null
          });
        });
      });
      that.createSkuList = _arrs;
    },
    setArr5(arrs1, arrs2, arrs3, arrs4) {
      let that = this;
      let _arrs = [];
      arrs1.list.forEach((v1, i1) => {
        arrs2.list.forEach((v2, i2) => {
          _arrs.push({
            specName: `${v1.specValue}--${v2.specValue}`,
            skuSpecs: `${v1.specId}:${v1.id},${v2.specId}:${v2.id}`,
            supSkuCode: "",
            skuPicUrl: "",
            defaultStock: 0,
            costPrice: 0,
            marketPrice: 0,
            billPrice: 0,
            thirdPrice: 0,
            customerPrice: 0,
            merchantPrice: 0,
            areaStocks: [],
            unitRebate: 0,
            monthRebate: 0,
            orderRebate: 0,
            structRebate: 0,
            subsidy: 0,
            highPurchaseAfterRebate: 0,
            strikePrice: null,
            grossProfit: 0,
            isInstallSubsidy: false,
            installSubsidyVal: null,
            skuPicUrl: null
          });
        });
      });
      that.setArr6(_arrs, arrs3, arrs4);
    },
    setArr6(arrs1, arrs2, arrs3) {
      let that = this;
      let _arrs = [];
      arrs1.forEach((v1, i1) => {
        arrs2.list.forEach((v2, i2) => {
          _arrs.push({
            specName: `${v1.specName}--${v2.specValue}`,
            skuSpecs: `${v1.skuSpecs},${v2.specId}:${v2.id}`,
            supSkuCode: "",
            skuPicUrl: "",
            defaultStock: 0,
            costPrice: 0,
            marketPrice: 0,
            billPrice: 0,
            thirdPrice: 0,
            customerPrice: 0,
            merchantPrice: 0,
            areaStocks: [],
            unitRebate: 0,
            monthRebate: 0,
            orderRebate: 0,
            structRebate: 0,
            subsidy: 0,
            highPurchaseAfterRebate: 0,
            strikePrice: null,
            grossProfit: 0,
            isInstallSubsidy: false,
            installSubsidyVal: null,
            skuPicUrl: null
          });
        });
      });
      that.setArr4(_arrs, arrs3);
    },
    //选择规格值
    selCheckboxFun() {
      let that = this;
      let arrs = [];
      this.createSkuCopyList = [...this.createSkuList];
      that.selAllSpec.forEach((v, i) => {
        arrs.push({
          list: [],
        });
        v.selScepIds.forEach((v1, i1) => {
          v.data.forEach((v2, i2) => {
            if (v1 == v2.id) {
              arrs[i].list.push(v2);
            }
          });
        });
      });
      //当规格为一个
      if (arrs.length == 1) {
        that.setArr(arrs);
        //当规格为二个
      } else if (arrs.length == 2) {
        if (arrs[0].list[0] && !arrs[1].list[0]) {
          arrs.splice(1, 1);
          that.setArr(arrs);
        } else if (!arrs[0].list[0] && !arrs[1].list[0]) {
          that.createSkuList = [];
        } else if (!arrs[0].list[0] && arrs[1].list[0]) {
          arrs.splice(0, 1);
          that.setArr(arrs);
        } else if (arrs[0].list[0] && arrs[1].list[0]) {
          that.setArr2(arrs[0], arrs[1]);
        }
        //当规格为三个
      } else if (arrs.length == 3) {
        if (!arrs[0].list[0] && !arrs[1].list[0] && !arrs[2].list[0]) {
          that.createSkuList = [];
        } else if (!arrs[0].list[0] && !arrs[1].list[0] && arrs[2].list[0]) {
          arrs.splice(0, 1);
          arrs.splice(0, 1);
          that.setArr(arrs);
        } else if (!arrs[0].list[0] && arrs[1].list[0] && arrs[2].list[0]) {
          arrs.splice(0, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (arrs[0].list[0] && !arrs[1].list[0] && !arrs[2].list[0]) {
          arrs.splice(1, 1);
          arrs.splice(1, 1);
          that.setArr(arrs);
        } else if (!arrs[0].list[0] && arrs[1].list[0] && !arrs[2].list[0]) {
          arrs.splice(0, 1);
          arrs.splice(1, 1);
          that.setArr(arrs);
        } else if (arrs[0].list[0] && arrs[1].list[0] && !arrs[2].list[0]) {
          arrs.splice(2, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (arrs[0].list[0] && !arrs[1].list[0] && arrs[2].list[0]) {
          arrs.splice(1, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (arrs[0].list[0] && arrs[1].list[0] && arrs[2].list[0]) {
          that.setArr3(arrs[0], arrs[1], arrs[2]);
        }
        //当规格为四个
      } else if (arrs.length == 4) {
        if (
          !arrs[0].list[0] &&
          !arrs[1].list[0] &&
          !arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          that.createSkuList = [];
        } else if (
          arrs[0].list[0] &&
          !arrs[1].list[0] &&
          !arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(1, 1);
          arrs.splice(1, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (
          !arrs[0].list[0] &&
          arrs[1].list[0] &&
          arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          arrs.splice(0, 1);
          arrs.splice(2, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (
          !arrs[0].list[0] &&
          !arrs[1].list[0] &&
          arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          arrs.splice(0, 1);
          arrs.splice(0, 1);
          arrs.splice(1, 1);
          that.setArr(arrs);
        } else if (
          !arrs[0].list[0] &&
          !arrs[1].list[0] &&
          !arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(0, 1);
          arrs.splice(0, 1);
          arrs.splice(0, 1);
          that.setArr(arrs);
        } else if (
          !arrs[0].list[0] &&
          !arrs[1].list[0] &&
          arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(0, 1);
          arrs.splice(0, 1);
          that.setArr2(arrs[0], arrs[1]);
        } else if (
          !arrs[0].list[0] &&
          arrs[1].list[0] &&
          arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(0, 1);
          that.setArr3(arrs[0], arrs[1], arrs[1]);
        } else if (
          arrs[0].list[0] &&
          !arrs[1].list[0] &&
          arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(1, 1);
          that.setArr3(arrs[0], arrs[1], arrs[2]);
        } else if (
          arrs[0].list[0] &&
          arrs[1].list[0] &&
          !arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          arrs.splice(2, 1);
          that.setArr3(arrs[0], arrs[1], arrs[2]);
        } else if (
          arrs[0].list[0] &&
          arrs[1].list[0] &&
          arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          arrs.splice(3, 1);
          that.setArr3(arrs[0], arrs[1], arrs[2]);
        } else if (
          arrs[0].list[0] &&
          arrs[1].list[0] &&
          arrs[2].list[0] &&
          arrs[3].list[0]
        ) {
          that.setArr5(arrs[0], arrs[1], arrs[2], arrs[3]);
        } else if (
          arrs[0].list[0] &&
          !arrs[1].list[0] &&
          !arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          arrs.splice(1, 1);
          arrs.splice(1, 1);
          arrs.splice(1, 1);
          that.setArr(arrs);
        } else if (
          arrs[0].list[0] &&
          arrs[1].list[0] &&
          !arrs[2].list[0] &&
          !arrs[3].list[0]
        ) {
          arrs.splice(2, 1);
          arrs.splice(2, 1);
          that.setArr2(arrs[0], arrs[1]);
        }
      }
      console.log(this.createSkuList, 'this.createSkuList')
    },
    delSpecValue(index) {
      this.selectScepIds.splice(index, 1);
      this.selAllSpec.splice(index, 1);
      this.createSkuList = [];
      this.selCheckboxFun();
    },
    setRegStock(index) {
      this.areaStockIndex = index;
      if (!this.goodDetailForm.isSingleSpec) {
        this.goodDetailForm.skus = this.createSkuList;
        this.regStockSkuId = this.createSkuList[index].id || 0;
      } else {
        // this.regStockSkuId = this.goodDetailForm.skus[index].Id;
        this.regStockSkuId = this.oneSkuList[index].id || 0;
      }
      this.regStockVisible = true;
    },
    setAreaShowSubmit() {
      this.$refs.regstock.submitAreaData();
      this.regStockVisible = false;
    },
    updateSkuPriceCheck() {
      let list = [];
      list.push(JSON.parse(this.$route.query.id));
      let data = {
        path: 'Product_Spu/BatchUpdateSkuPriceCheck',
        parms: '',
        parmsJson: {
          spuIds: list
        }
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          if (res.data.response.isTieredPricing) {
            // this.ladderVisible = true
            this.$confirm(
              "该商品存在阶梯价格，若有需要请记得手动修改阶梯价格。",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                closeOnClickModal: false,
                type: "warning",
              }
            ).then(() => {
              this.addOrUpdata();
            });
          } else {
            this.addOrUpdata();
          }
        }
      });
    },
    getTypeName(data) {
      setTimeout(() => {
        // this.selTypeName = document.querySelector('.type_cascader input').value
        // console.log(document.querySelector('.type_cascader input').value)
        this.selTypeName = this.$refs.type_cascader.getCheckedNodes()[0].pathLabels.join("/")
      }, 100)
      // data.forEach((item) => {
      //   if (
      //     item.id ===
      //     this.goodDetailForm.typeIdList[
      //     this.goodDetailForm.typeIdList.length - 1
      //     ]
      //   ) {
      //     this.selTypeName = item.typeName;
      //   } else {
      //     if (item.childrens) {
      //       this.getTypeName(item.childrens);
      //     }
      //   }
      // });
    },
    addOrUpdata() {
      this.updateProName()
      let checkBrand = this.brandmodelData.name
      let checkModelCode = this.goodDetailForm.modelCode
      let checkType = ""
      try {
        checkType = this.$refs.type_cascader.getCheckedNodes()[0].pathLabels.join("");
      } catch (error) { }
      const proName = this.goodDetailForm.proName;
      const brandCount = (proName.match(new RegExp(checkBrand, 'gi')) || []).length;
      const typeCount = (proName.match(new RegExp(checkType, 'gi')) || []).length;
      const modelCount = (proName.match(new RegExp(checkModelCode, 'gi')) || []).length;
      if (brandCount > 1 || typeCount > 2 || modelCount > 1) {
        this.$message.warning("品类在名称中只能出现2次，品牌只能出现1次，型号只能出现1次");
        return false;
      }

      // 匹配品类
      this.getTypeName(this.productNavTypeTreeList);
      this.proNameConfirmVisible = true;
      let isBrandValid =
        this.goodDetailForm.proName.indexOf(this.brandmodelData.name) > -1;
      let isModeCodeValid =
        this.goodDetailForm.proName.indexOf(this.goodDetailForm.modelCode) > -1;
      // let isTypeNameValid = this.goodDetailForm.proName.indexOf(this.selTypeName) > -1;
      // 用完整的品类名称验证,只要包含任何一个都算通过
      let isTypeNameValid = false
      let types = this.typeNameString.split(',')
      if (types.length) {
        for (var t = 0; t < types.length; t++) {
          if (this.goodDetailForm.proName.indexOf(types[t]) > -1) {
            isTypeNameValid = true
            break;
          }
        }
      }
      if (
        isBrandValid &&
        isModeCodeValid &&
        isTypeNameValid &&
        this.goodDetailForm.parameters.length &&
        this.goodDetailForm.seriesName &&
        this.goodDetailForm.simpleSellingPoint &&
        this.goodDetailForm.extraSellingPoint
      ) {
        this.proNameConfirmFlag = true;
      } else {
        this.proNameConfirmFlag = false;
        this.proNameConfirmText = `当前商品信息不完整，<span style="color:red;">${isBrandValid ? "" : "品牌，"
          }${isTypeNameValid ? "" : "品类，"}${isModeCodeValid ? "" : "型号，"}${this.goodDetailForm.seriesName ? "" : "系列名，"
          }${this.goodDetailForm.parameters.length ? "" : "参数，"
          }${this.goodDetailForm.simpleSellingPoint ? "" : "卖点，"}${this.goodDetailForm.extraSellingPoint ? "" : "补充卖点，"
          }</span>信息需要补充，标准商品名称所需信息有：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点`;
      }
    },
    addOrUpdata_() {
      let that = this;
      // if(!this.videoUrl){
      //   return this.$message.error('请上传商品视频')
      // }
      that.goodDetailForm.videoPath = this.videoUrl;
      if (that.goodDetailForm.isSingleSpec) {
        if (!that.oneSkuList[0].skuPicUrl) {
          that.goodDetailForm.businessPics.forEach((v) => {
            if (v.isMain) {
              that.oneSkuList[0].skuPicUrl = v.spuPicUrl;
            }
          });
        }
        // delete that.oneSkuList[0].skuSpecs;
        that.oneSkuList[0].orderRebate = Number(that.oneSkuList[0].orderRebate)
        that.oneSkuList[0].installSubsidyVal = Number(that.oneSkuList[0].installSubsidyVal)
        that.goodDetailForm.skus = that.oneSkuList;
        that.goodDetailForm.skus[0].isInstallSubsidy = false
      } else {
        that.goodDetailForm.skus = that.createSkuList;
      }
      if (!that.goodDetailForm.modelCode) {
        return that.$message.error('请选择型号！')
      }
      if (!that.goodDetailForm.proName)
        return that.$message.error("请输入商品名称！");
      if (!that.goodDetailForm.supId)
        return that.$message.error("请选择商品供应商！");
      // if (!that.goodDetailForm.typeIdList || !document.querySelector('.productTypeSelect input').value)
      //   return that.$message.error("请选择商品类型！");
      if (that.goodDetailForm.typeIdList.length < 2)
        return that.$message.error("商品类型至少选到2级！");
      if (!that.goodDetailForm.brandId)
        return that.$message.error("请选择商品品牌！");
      let Bpics = that.goodDetailForm.businessPics.filter(v => v.spuPicUrl)
      if (!Bpics[0])
        return that.$message.error("请上传商品商家端展示图册！");
      const type3Item = Bpics.find(item => item.type === 3)
      if (!type3Item || !type3Item.spuPicUrl) {
        this.$message.warning('请上传主图(场景图)1')
        return
      }
      let Cpics = that.goodDetailForm.customerPics.filter(v => v.spuPicUrl)
      if (!Cpics[0])
        return that.$message.error("请上传商品C端展示图册！");
      if (!that.goodDetailForm.proContent)
        return that.$message.error("请填写商品描述！");
      if (!that.goodDetailForm.orderNotice) {
        return that.$message.error("请填写下单须知！");
      }
      if (that.goodDetailForm.isInRoom && !that.goodDetailForm.inRoomNotice) {
        return that.$message.error("请填写入户商品内容提醒！");
      }
      // if (this.goodDetailForm.isPreSale && !this.goodDetailForm.preSaleDescribe) {
      //   return this.$message.error('请填写预售说明！')
      // }
      // if (this.goodDetailForm.skus[0].grossProfit) {
      //   let reg = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$/;
      //   if (!reg.test(this.goodDetailForm.skus[0].grossProfit)) {
      //     return this.$message.error('0<=毛利率<=100，保留两位小数，非必填，默认值为0');
      //   }
      // }
      if (RegExp(/测试/).test(that.goodDetailForm.proName)) { // 测试商品不允许推荐
        that.goodDetailForm.isRecommend = false
      }
      // 根据是否显示下单返利 校验到手价
      if (that.isStrickPriceShow)
        if (!that.goodDetailForm.skus[0].strikePrice) {
          return that.$message.error("到手价不能为空！");
        }

      var _skus = that.goodDetailForm.skus;
      for (let i = 0; i < _skus.length; i++) {
        if (!_skus[i].defaultStock) {
          return that.$message.error(`库存不能为0！`);
        }
        if (!_skus[i].billPrice) {
          _skus[i].billPrice = 0
        }
        if (this.priceType == 1 && this.supType == 1) {
          _skus[i].merchantPrice = (_skus[i].billPrice / 0.985).toFixed(2)
          _skus[i].customerPrice = (_skus[i].billPrice / 0.95).toFixed(2)
          _skus[i].marketPrice = (_skus[i].billPrice / 0.93).toFixed(2)
        }
        if (this.supType === 2) {
          _skus[i].merchantPrice = _skus[i].billPrice
          _skus[i].customerPrice = _skus[i].billPrice
          _skus[i].marketPrice = _skus[i].billPrice
        }
        if (this.priceType === 2 && this.supType === 1) {
          if (
            // _skus[i].marketPrice > _skus[i].customerPrice &&
            _skus[i].customerPrice > _skus[i].merchantPrice &&
            _skus[i].merchantPrice > _skus[i].billPrice
          ) { } else {
            return this.$message.warning("零售价>商家价>采购价")
            // return this.$message.warning("市场价>零售价>商家价>采购价")
          }
        }
        /*
        *  TODO 验证加不上
        *   */
        // if (_skus[i].grossProfit) {
        //   let reg = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$/;
        //   if (!reg.test(_skus[i].grossProfit)) {
        //     return this.$message.error('0<=毛利率<=100，保留两位小数，非必填，默认值为0');
        //   }
        // }
        if (
          // _skus[i].costPrice == 0 ||
          // _skus[i].marketPrice == 0 ||
          _skus[i].customerPrice == 0 ||
          _skus[i].merchantPrice == 0
          // _skus[i].strikePrice == 0
        ) {
          return that.$message.error(
            `${_skus[i].specName ? _skus[i].specName : ""}价格不能为0！`
          );

        }
        // if (_skus[i].billPrice == '') {
        //   return that.$message.error('供货价格必填')
        // }
        // else if (
        //   Number(_skus[i].merchantPrice) > Number(_skus[i].customerPrice)
        // ) {
        //   return that.$message.error(
        //     `${_skus[i].specName ? _skus[i].specName : ""
        //     }商家价格不能大于零售价格！`
        //   );
        // } else if (
        //   Number(_skus[i].customerPrice) > Number(_skus[i].marketPrice)
        // ) {
        //   return that.$message.error(
        //     `${_skus[i].specName ? _skus[i].specName : ""
        //     }零售价格不能大于市场价格！`
        //   );
        // }
        // else if (
        //   Number(_skus[i].strikePrice) > Number(_skus[i].merchantPrice) && that.isStrickPriceShow
        // ) {
        //   return that.$message.error(
        //     `${_skus[i].specName ? _skus[i].specName : ""
        //     }到手价不能大于商家价！`
        //   );
        // }
        if (_skus[i].costPrice) {
          const price = _skus[i].afterPrice || _skus[i].costPrice;
          let maori = (_skus[i].merchantPrice - price) / _skus[i].merchantPrice
          // console.log(_skus[i].afterPrice, _skus[i].costPrice, _skus[i].merchantPrice, maori, that.StandardRate);
          // if (maori < that.StandardRate) {
          //   this.$message.error('对应毛利低于所配置的标准品类毛利标准，提交后需进行审批！')
          // }
        }
      }
      if (that.goodDetailForm.areaLimtId) {
        that.goodDetailForm.isAreaLimt = true;
      } else {
        that.goodDetailForm.isAreaLimt = false;
      }
      let list = that.goodDetailForm.properties || []
      if (list && list[0]) {
        that.goodDetailForm.properties = that.goodDetailForm.properties.filter(item => {
          if (item.propertyType == 10) {
            return item.propertyValue
          } else {
            return item.propertyValueIds.length > 0
          }
        })
      }
      const { promoteTag, promoteEndTime, promoteDeliveryTimeTag } = that.goodDetailForm;
      // if (promoteTag !== 0 && promoteTag !== 1 && promoteTag !== 2) {
      //   return this.$message.error('请设置活动!')
      // }
      // if (Number(promoteTag) == 1 || Number(promoteTag) == 2) {
      //   if (!promoteEndTime) {
      //     return this.$message.error('请填写活动结束时间');
      //   }
      //   if (!promoteDeliveryTimeTag) {
      //     return this.$message.error('请填写活动结束后发货时效');
      //   }
      // }
      // if (Number(that.goodDetailForm.minBuyNum) <= 0) {
      //   return this.$message.error('商家起购数量至少为1台');
      // }
      // if (Number(that.goodDetailForm.minCustomerBuyNum) <= 0) {
      //   return this.$message.error('C端起购数量至少为1台');
      // }
      // if (that.goodDetailForm.deliveryTimeTag == null) {
      //   return this.$message.error('请设置发货时效');
      // }
      this.goodDetailForm.jargonIds = (this.goodDetailForm.jargonIds || []).join(",")
      let tempData = JSON.parse(JSON.stringify(that.goodDetailForm));
      tempData.businessPics = tempData.businessPics.filter(v => v.spuPicUrl)
      tempData.customerPics = tempData.customerPics.filter(v => v.spuPicUrl)
      that.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        if (!that.$route.query.id) {
          let params = {
            path: 'Product_Spu/Add',
            parms: '',
            parmsJson: tempData
          }
          KSAXApiRequest(params).then((res) => {
            if (res.data.success) {
              that.$message.success(res.data.msg);
              this.spuId = res.data.response
              this.getProductSpuDetail();
              // this.$router.go(0);
            } else {
              that.$message.error(res.data.msg);
            }
          });
        } else {
          let params = {
            path: 'Product_Spu/Update',
            parms: '',
            parmsJson: tempData
          }
          KSAXApiRequest(params).then((res) => {
            if (res.data.success) {
              that.$message.success(res.data.msg);
              this.getProductSpuDetail();
              // this.GetApprovalAfterPrice()
              // this.$router.go(0);
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    handleSave() {
      let that = this;
      // if(!this.videoUrl){
      //   return this.$message.error('请上传商品视频')
      // }
      that.goodDetailForm.videoPath = this.videoUrl;
      if (that.goodDetailForm.isSingleSpec) {
        delete that.oneSkuList[0].skuSpecs;
        that.goodDetailForm.skus = that.oneSkuList;
      } else {
        that.goodDetailForm.skus = that.createSkuList;
      }
      if (!that.goodDetailForm.proName)
        return that.$message.error("请输入商品名称！");
      if (!that.goodDetailForm.supId)
        return that.$message.error("请选择商品供应商！");
      if (!that.goodDetailForm.typeIdList)
        return that.$message.error("请选择商品类型！");
      if (!that.goodDetailForm.brandId)
        return that.$message.error("请选择商品品牌！");
      if (!that.goodDetailForm.businessPics[0])
        return that.$message.error("请上传商品商家端展示图册！");
      if (!that.goodDetailForm.customerPics[0])
        return that.$message.error("请上传商品C端展示图册！");
      if (!that.goodDetailForm.proContent)
        return that.$message.error("请填写商品描述！");
      that.$confirm("确认保存吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        // 编辑商品的时候
        let skuinfos = []
        if (this.$route.query.id) {
          if (this.goodDetailForm.isSingleSpec && this.oneSkuList[0].id) {
            skuinfos.push({
              spuId: this.oneSkuList[0].spuId,
              skuId: this.oneSkuList[0].id,
              skuPicUrl: this.oneSkuList[0].skuPicUrl
            })
          } else {
            that.createSkuList.forEach(item => {
              if (item.id) {
                skuinfos.push({
                  spuId: item.spuId,
                  skuId: item.id,
                  skuPicUrl: item.skuPicUrl
                })
              }
            })
          }
        }
        const {
          id,
          proName,
          modelCode,
          keyWord,
          description,
          supId,
          typeIdList,
          brandId,
          properties,
          videoPath,
          customerPics,
          businessPics,
          proContent
        } = that.goodDetailForm
        let data = {
          id,
          proName,
          modelCode,
          keyWord,
          description,
          supId,
          typeIdList,
          brandId,
          properties,
          videoPath,
          customerPics,
          businessPics,
          proContent
        }
        // 编辑商品的时候吧商品图也传过去
        if (this.$route.query.id && skuinfos.length) {
          data.skuInfos = skuinfos
        }
        PartUpdate(data).then((res) => {
          if (res.data.success) {
            that.$message.success(res.data.msg);
            this.getProductSpuDetail();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      });
    },
    onKeywordChange() {
      this.getProName()
    },
    handleSubmit() {
      // if (this.$route.query.id) {
      //   this.updateSkuPriceCheck();
      // } else {
      this.addOrUpdata();
      // }
    },
    submitProInfo() {
      this.proNameConfirmVisible = false;
      this.addOrUpdata_()
    },
    handleBrandInput(e) {
      this.getBrandList(e);
    },
    handleBrandSelect(e) {
      this.goodDetailForm.brandId = e.id;
      this.getProName()
    },
    handleSupInput(e) {
      this.getBusSupplierList(e);
    },
    handleSupSelect(e) {
      this.goodDetailForm.supId = e.id;
      this.supType = e.supType
      this.priceType = e.priceType
      if (this.goodDetailForm.isSingleSpec) {
        if (this.priceType == 1 && this.supType == 1) {
          this.oneSkuList[0].merchantPrice = (this.oneSkuList[0].billPrice / 0.985).toFixed(2)
          this.oneSkuList[0].customerPrice = (this.oneSkuList[0].billPrice / 0.95).toFixed(2)
          this.oneSkuList[0].marketPrice = (this.oneSkuList[0].billPrice / 0.93).toFixed(2)
        } else {
          this.oneSkuList[0].merchantPrice = this.oneSkuList[0].billPrice
          this.oneSkuList[0].customerPrice = this.oneSkuList[0].billPrice
          this.oneSkuList[0].marketPrice = this.oneSkuList[0].billPrice
        }
      } else {
        this.createSkuList.forEach(item => {
          if (this.priceType == 1 && this.supType == 1) {
            item.merchantPrice = (item.billPrice / 0.985).toFixed(2)
            item.customerPrice = (item.billPrice / 0.95).toFixed(2)
            item.marketPrice = (item.billPrice / 0.93).toFixed(2)
          } else {
            item.merchantPrice = item.billPrice
            item.customerPrice = item.billPrice
            item.marketPrice = item.billPrice
          }
        })
      }
    },
    handleDetail(index) {
      if (this.goodDetailForm.isSingleSpec) {
        this.skuId = this.oneSkuList[0].Id;
      } else {
        this.skuId = this.createSkuList[index].id;
      }
      this.areaVisible = true;
    },
    inputPayEffectiveTime(value) {
      if (!/^([1-9]\d*|[0])$/.test(value)) {
        this.goodDetailForm.payEffectiveTime = 0
      }
    },
    // 验证名称里是否含有关键字
    valideKeyWord(cb) {
      const proName = this.goodDetailForm.proName;
      const key = this.goodDetailForm.keyWords;
      if (!key) {
        if (cb) {
          return cb([])
        }
        return false;
      }

      const isDun = key.indexOf("、") > -1;
      const isDou = key.indexOf(",") > -1;
      const isCNDou = key.indexOf("，") > -1;
      const isSpa = key.indexOf(" ") > -1;
      let keyArr = [];
      if (isDun) {
        keyArr = key.split("、");
      } else if (isDou) {
        keyArr = key.split(",");
      } else if (isCNDou) {
        keyArr = key.split("，");
      } else if (isSpa) {
        keyArr = key.split(" ");
      } else {
        keyArr = [key];
      }
      if (cb) {
        // 这里只做获取关键字列表
        return cb(keyArr)
      }
      let bool = false;
      for (var i = 0; i < keyArr.length; i++) {
        if (proName.indexOf(keyArr[i]) > -1) {
          bool = true;
          break;
        }
      }
      return bool;
    },
    // 获取审批中的返价
    GetApprovalAfterPrice() {
      let that = this;
      if (that.spuId) {
        let params = {
          spuId: that.spuId,
        };
        GetApprovalAfterPrice(params).then((res) => {
          if (res.data.success) {
            that.approvalAfterPrice = res.data.response
            if (that.approvalAfterPrice) {
              this.$message.error('价格正在审批')
            }
          } else {
            // that.$message.error(res.data.msg);
          }
        });
      }
    },
    HandleIsInstallSubsidy(value) {
      console.log('value', value);
      if (!value) {
        this.goodDetailForm.skus[0].installSubsidyVal = null
        this.goodDetailForm.skus[0].orderRebate = 0
      }
    },
    HandleIsInstallSubsidyItem(value, item) {
      if (!value) {
        item.installSubsidyVal = null
      }
    },
    GetReturnMemberRebateConfig() {
      GetReturnMemberRebateConfig({
        skuId: this.oneSkuList[0].id
      }).then((res) => {
        if (res.data.success) {
          this.activityConfig = res.data.response
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleActivityConfig() {
      let { href } = this.$router.resolve({
        path: `/RuleSet/BeanProduct/Index?skuId=${this.oneSkuList[0].Id}`,
      });
      window.open(href, "_blank");
    },
    regionalRestrictions() {
      let { href } = this.$router.resolve({
        path: `/Product/AreaLimit/List`,
      });
      window.open(href, "_blank");
    },
    getGargonData() {
      const BrandId = this.goodDetailForm.brandId
      const TypeId = this.goodDetailForm.typeIdList[this.goodDetailForm.typeIdList.length - 1]
      const ModelCode = this.goodDetailForm.modelCode
      if (BrandId && BrandId && ModelCode) {
        KSAXApiRequest({
          path: 'Product_SpuJargon/List',
          parms: '',
          parmsJson: {
            BrandId,
            TypeId,
            ModelCode,
            PageIndex: 1,
            PageSize: 200
          }
        }).then((res) => {
          if (res.data.success) {
            this.jargonData = res.data.response.data
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        this.jargonData = []
      }
    },
    getKeyWordData(cb) {
      const BrandId = this.goodDetailForm.brandId
      const TypeId = this.goodDetailForm.typeIdList[this.goodDetailForm.typeIdList.length - 1]
      const ModelCode = this.goodDetailForm.modelCode
      if (BrandId && BrandId && ModelCode) {
        KSAXApiRequest({
          path: 'SpuKeyWord/List',
          parms: '',
          parmsJson: {
            PageIndex: 1,
            PageSize: 200,
            BrandId,
            TypeId,
            AuditResult: 1,
            IsEnable: true,
            ModelCode,
          }
        }).then((res) => {
          if (res.data.success) {
            this.goodDetailForm.keyWords = (res.data.response.data || []).map(item => {
              return item.keyWord
            }).join(',')
            cb && cb()
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        this.goodDetailForm.keyWords = ""
        cb && cb()
      }
    },
    updateProName() {
      this.$nextTick(() => {
        let brand = this.brandmodelData.name || ""
        let type = this.$refs.type_cascader.getCheckedNodes()[0].pathLabels
        let modelCode = this.goodDetailForm.modelCode || ""
        // let keyWords = (this.goodDetailForm.keyWords || "").split(",").join("")
        // let jargon = this.goodDetailForm.jargonIds.map(id => {
        //   const item = this.jargonData.find(d => d.id === id);
        //   return item ? item.spuJargon : null;
        // }).filter(Boolean).join('');
        let parameters = this.goodDetailForm.parameters.filter(item => item.value !== "无").map(item => {
          return item.value
        }).slice(0, 3).join("")
        let getParameter = (params) => {
          if ((this.goodDetailForm.parameters || []).filter(item => item.key === params).length) {
            return (this.goodDetailForm.parameters || []).filter(item => item.key === params)[0].value
          } else {
            return ""
          }
        }
        let seriesName = this.goodDetailForm.seriesName || ""
        let simpleSellingPoint = this.goodDetailForm.simpleSellingPoint || ""
        let extraSellingPoint = this.goodDetailForm.extraSellingPoint || ""
        if (this.goodDetailForm.typeIdList && this.goodDetailForm.typeIdList.length) {
          if (this.goodDetailForm.typeIdList[0] === 1) {
            let parameter1 = getParameter("能效等级")
            let parameter2 = getParameter("匹数")
            let parameter3 = getParameter("变频/定频")
            let parameter4 = getParameter("冷暖类型")
            this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${parameter4} ${simpleSellingPoint} ${extraSellingPoint}`
            this.proNameMessage = "空调：品牌 + 一级品类 + 型号 + 系列名 + 能效等级 + 匹数 + 变频/定频 + 冷暖类型 + 卖点 + 补充卖点"
          } else if (this.goodDetailForm.typeIdList[0] === 64) {
            let parameter1 = getParameter("能效等级")
            let parameter2 = getParameter("总容积（L)")
            let parameter3 = getParameter("制冷方式")
            let parameter4 = getParameter("面板材质")
            this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${parameter4} ${simpleSellingPoint} ${extraSellingPoint}`
            this.proNameMessage = "冰箱：品牌 + 一级品类 + 型号 + 系列名 + 能效等级 + 总容积（L) + 制冷方式 + 面板材质 + 卖点 + 补充卖点"
            if (this.goodDetailForm.typeIdList[1] === 71) {
              this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${parameter4} ${simpleSellingPoint} ${extraSellingPoint}`
            }
          } else if (this.goodDetailForm.typeIdList[0] === 72) {
            let parameter1 = getParameter("能效等级")
            let parameter2 = getParameter("屏幕尺寸")
            let parameter3 = getParameter("运行+存储内存")
            let parameter4 = getParameter("刷屏率")
            this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${parameter4} ${simpleSellingPoint} ${extraSellingPoint}`
            this.proNameMessage = "电视：品牌 + 一级品类 + 型号 + 系列名 + 能效等级 + 屏幕尺寸 + 运行+存储内存 + 刷屏率 + 卖点 + 补充卖点"
          } else if (this.goodDetailForm.typeIdList[0] === 78) {
            if (this.goodDetailForm.typeIdList[1]) {
              if (this.goodDetailForm.typeIdList[1] === 81) {
                let parameter1 = getParameter("变频/定频")
                let parameter2 = getParameter("洗涤容量")
                let parameter3 = getParameter("盖板材质")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "波轮洗衣机：品牌 + 二级品类 + 型号 + 变频/定频 + 洗涤容量 + 盖板材质 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 79) {
                let parameter1 = getParameter("变频/定频")
                let parameter2 = getParameter("洗涤容量")
                let parameter3 = getParameter("嵌入方式")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "滚筒洗衣机：品牌 + 二级品类 + 型号 + 变频/定频 + 洗涤容量 + 嵌入方式 + 卖点 + 补充卖点"
              } else {
                this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
              }
            } else {
              this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
              this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
            }
          } else if (this.goodDetailForm.typeIdList[0] === 85) {
            if (this.goodDetailForm.typeIdList[1]) {
              if (this.goodDetailForm.typeIdList[1] === 90) {
                let parameter1 = getParameter("能效等级")
                let parameter2 = getParameter("容量")
                let parameter3 = getParameter("操控方式")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "电热水器：品牌 + 二级品类 + 型号 + 系列名 + 能效等级 + 容量 + 操控方式 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 87) {
                let parameter1 = getParameter("能效等级")
                let parameter2 = getParameter("排风量")
                let parameter3 = getParameter("烟机款式")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "油烟机：品牌 + 二级品类 + 型号 + 系列名 + 能效等级 + 排风量 + 烟机款式 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 94) {
                let parameter1 = getParameter("能效等级")
                let parameter2 = getParameter("燃热出水量")
                let parameter3 = getParameter("气源")
                let parameter4 = getParameter("零冷水/水伺服")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${parameter4} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "燃气热水器：品牌 + 二级品类 + 型号 + 系列名 + 能效等级 + 燃热出水量 + 气源 + 零冷水/水伺服 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 89) {
                let parameter1 = getParameter("能效等级")
                let parameter2 = getParameter("火力")
                let parameter3 = getParameter("气源")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "燃气灶：品牌 + 二级品类 + 型号 + 系列名 + 能效等级 + 火力 + 气源 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 91) {
                let parameter1 = getParameter("能效级别")
                let parameter2 = getParameter("餐具容量")
                let parameter3 = getParameter("类型")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "洗碗机：品牌 + 二级品类 + 型号 + 系列名 + 能效级别 + 餐具容量 + 类型 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 93) {
                let parameter1 = getParameter("能效等级")
                let parameter2 = getParameter("气源")
                let parameter3 = getParameter("功能组合")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "集成灶：品牌 + 二级品类 + 型号 + 系列名 + 能效等级 + 气源 + 功能组合 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 333) {
                let parameter1 = getParameter("能效级别")
                let parameter2 = getParameter("气源")
                let parameter3 = getParameter("供暖面积")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "燃气壁挂炉：品牌 + 二级品类 + 型号 + 系列名 + 能效级别 + 气源 + 供暖面积 + 卖点 + 补充卖点"
              } else if (this.goodDetailForm.typeIdList[1] === 3525) {
                let parameter1 = getParameter("出水量")
                let parameter2 = getParameter("安装方式")
                let parameter3 = getParameter("制冷/制热")
                this.goodDetailForm.proName = `${brand} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameter1} ${parameter2} ${parameter3} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "净水器：品牌 + 二级品类 + 型号 + 系列名 + 出水量 + 安装方式 + 制冷/制热 + 卖点 + 补充卖点"
              } else {
                this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
                this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
              }
            } else {
              this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
              this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
            }
          } else {
            this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
            this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
          }
        } else {
          this.goodDetailForm.proName = `${brand} ${type[0] ? type[0] : ""} ${type[1] ? type[1] : ""} ${modelCode} ${seriesName} ${parameters} ${simpleSellingPoint} ${extraSellingPoint}`
          this.proNameMessage = "商品名称：品牌 + 一级品类 + 二级品类 + 型号 + 系列名 + 参数 + 卖点 + 补充卖点"
        }
        this.goodDetailForm.proName = this.goodDetailForm.proName.replace(/ +/g, ' ');
      })
    },
    async product_SpuModelGetSimpleList() {
      const { modelCode } = this.goodDetailForm
      if (modelCode) {
        let data = {
          path: 'Product_SpuModel/GetSimpleList',
          parms: '',
          parmsJson: {
            modelCode
          }
        }
        let res = await KSAXApiRequest(data)
        if (res.data.success) {
          let item = res.data.response.filter(item => item.modelCode === modelCode)[0]
          if (item) {
            this.product_SpuModelDetail(item.id)
          }
        }
      }
    },
    product_SpuModelDetail(id) {
      let data = {
        path: 'Product_SpuModel/GetDetail',
        parms: `id=${id}`
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          let {
            seriesName,
            simpleSellingPoint
          } = res.data.response
          if (!this.goodDetailForm.seriesName) {
            this.goodDetailForm.seriesName = seriesName
          }
          if (!this.goodDetailForm.simpleSellingPoint) {
            this.goodDetailForm.simpleSellingPoint = simpleSellingPoint
          }
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    stockDetail(row) {
      this.$refs.stockDetail.init(row.id, this.goodDetailForm.modelCode, this.goodDetailForm.supId)
    }
  },
};
</script>
<style scoped>
.add_main {
  min-height: 100%;
  padding: 10px 20px 100px 20px;
  overflow: hidden;
}

.header_tit {
  height: 30px;
  width: 100%;
  color: #111111;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}

.header_tit .red_box {
  width: 4px;
  height: 14px;
  border-radius: 2px;
  margin-right: 10px;
  background: #2064FF;
  /* background: linear-gradient(0deg, rgba(242, 64, 93, 1), rgba(238, 52, 83, 1)); */
}

.el-input,
.el-select,
.el-cascader,
.el-autocomplete {
  width: 80%;
}

.el-textarea {
  width: 78%;
}

.el-form {
  padding-left: 20px;
}

.tab_box {
  padding: 20px;
}

.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.set_main {
  position: absolute;
  bottom: -40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-share {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-home-business {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-home-customer {
  position: absolute;
  bottom: -100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.params_box div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.from_tit {
  color: #606266;
  margin-right: 20px;
}

.params_box ul {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.params_box ul>li {
  padding: 0 10px;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  margin-right: 20px;
}

.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}

.single_up_img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el_upload_sku {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  border: 1px solid #999;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
}

.el-table table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.el-table thead {
  color: #909399;
  table-layout: fixed;
  border-collapse: separate;
  font-weight: 500;
}

.el-table th,
.el-table tr {
  background: #fff;
}

.el-table .el-table__body td,
.el-table .el-table__header tr th {
  padding: 0;
  background: #f6f7f9;
  border-right: 1px solid #dde5e8;
  border-bottom: 1px solid #dde5e8;
  text-align: center;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-table .el-table__header th:first-child div.cell {
  border-left: 0;
  background: #f6f7f9;
  padding: 7px 8px;
  font-weight: 100;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}

.el-table th,
.el-table tr {
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  border-right: 1px solid #dfe6ec;
}

.el-table .el-table__body td div.cell {
  font-size: 12px;
  padding: 9px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.cell .el-input {
  width: 100%;
}

.avatar-box {
  height: 100px;
  width: 100px;
}

.up_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.download_box {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 999;
  width: 150px;
  height: 150px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  overflow: hidden;
}

.image-box {
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  position: relative;
  margin: 0 10px 20px 0;
}

.image-box .img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
}

.image-box .text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;
}

.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  display: inline-block;
}

.img-box .el_upload:hover {
  border-color: #409eff;
}

.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 120px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}

.img-box .avatar {
  width: 120px;
  height: 120px;
}

.el_upload_video {
  display: inline-block !important;
}

.el_upload_video .video {
  padding-left: 20px;
}

.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box>>>img {
  width: 20px !important;
  height: 20px !important;
}

.img_box .multi_box {
  width: 120px !important;
  height: 120px !important;
}

.videoPreview {
  margin-left: 30px !important;
  display: inline-block;
  width: 120px;
  height: 120px;
  overflow: hidden;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.videoWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
}

.videoWrapInner {
  background: white;
  width: 600px;
  height: 400px;
}

.play_btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 2;
  cursor: pointer;
}
</style>
<style scoped>
.limit-input .el-input {
  width: 80px !important;
}

.flex-wrap {
  display: flex;
}

.flex-start {
  align-items: flex-start;
}

.child-tab {}

.child-tab li {
  padding: 5px 0;
  border: 1px solid #EBEEF5;
}

.child-tab li p {
  text-align: center;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #EBEEF5;
}

.child-tab li div {
  padding: 0 5px;
}

.query-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: #DCDFE6;
  text-align: center;
  line-height: 20px;
  font-size: 13px;
  margin-right: 10px;
  cursor: pointer;
}

.colorRed {
  color: red;
  font-size: 12px;
  line-height: 2;
}
</style>
